import { useState, useEffect, useRef } from "react";
import { createClient } from "@supabase/supabase-js";

// ─── SUPABASE CLIENT ─────────────────────────────────────────────────────────
const supabase = createClient(
  "https://lqoinssqbirqdroggaiv.supabase.co",
  "sb_publishable_A_CL1-zE4jV-co7gQWeTpQ_1toAdOwy"
);

const FONTS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=Montserrat:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap');
`;

// ─── DATA ────────────────────────────────────────────────────────────────────

const PRODUCTS = []; // Produtos carregados do Supabase

// ─── KITS DEFAULT ────────────────────────────────────────────────────────────
const DEFAULT_KITS = []; // Kits carregados do Supabase


// USERS removido — autenticação via Supabase Auth

const COLOR_HEX = {
  "Preto": "#1a1a1a", "Marinho": "#1e3a5f", "Cinza Chumbo": "#4a4a4a",
  "Cinza Claro": "#9ca3af", "Bege": "#d4c4a0", "Caramelo": "#c9965a",
  "Bordô": "#7b1c2e", "Azul Royal": "#1565c0", "Verde Oliva": "#4a5e3a",
  "Grafite": "#3d3d3d", "Caqui": "#a89060", "Marrom": "#6b4226",
  "Areia": "#d4b896", "Vinho": "#5c1f35", "Chocolate": "#4a2515",
  "Azul Petróleo": "#1a3a4a", "Terracota": "#8b4a30", "Camelo": "#c4956a", "Branco Noiva": "#fafaf7", "Marfim": "#f5f0e0", "Champagne": "#e8d5b0", "Rosê": "#f2c4b0", "Nude": "#d4a898", "Prata": "#c0c0c0",
};

// ─── STYLES ──────────────────────────────────────────────────────────────────

const css = `
  ${FONTS}
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --black: #0a0a0f;
    --navy: #0f1a2e;
    --cream: #f5f0e8;
    --parchment: #ede8df;
    --accent: #b8965a;
    --accent2: #d4af78;
    --gray: #7a7a7a;
    --light: #f0ebe0;
    --white: #ffffff;
    --border: #ddd8cc;
    --gold: #c9a96e;
    --gold-light: #e8d5a3;
    --font-display: 'Cormorant Garamond', serif;
    --font-body: 'Montserrat', sans-serif;
    --font-serif: 'Playfair Display', serif;
    --font-mono: 'Montserrat', sans-serif;
  }
  html { scroll-behavior: smooth; }
  body { font-family: var(--font-body); background: var(--cream); color: var(--black); overflow-x: hidden; }
  
  /* NAV */
  .nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 1000;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 48px; height: 72px;
    background: var(--black);
    border-bottom: 1px solid rgba(185,150,90,0.3);
  }
  .nav-logo {
    font-family: var(--font-display); font-size: 22px; color: var(--white);
    letter-spacing: 5px; cursor: pointer; font-weight: 300; text-transform: uppercase;
  }
  .nav-logo span { color: var(--gold); }
  .nav-links { display: flex; gap: 40px; align-items: center; }
  .nav-link {
    font-family: var(--font-body); font-size: 11px; font-weight: 500;
    text-transform: uppercase; letter-spacing: 2.5px; color: rgba(255,255,255,0.6);
    cursor: pointer; border: none; background: none; padding: 0;
    transition: color 0.3s;
  }
  .nav-link:hover { color: var(--gold); }
  .nav-btn {
    font-family: var(--font-body); font-size: 11px; font-weight: 600;
    text-transform: uppercase; letter-spacing: 2px;
    padding: 10px 24px; cursor: pointer;
    background: var(--gold); color: var(--black); border: none;
    transition: all 0.3s;
  }
  .nav-btn:hover { background: var(--gold-light); }
  .nav-btn.outline {
    background: transparent; border: 1px solid rgba(185,150,90,0.5); color: var(--gold);
  }
  .nav-btn.outline:hover { border-color: var(--gold); background: rgba(185,150,90,0.1); }

  /* HERO */
  .hero {
    min-height: 100vh; background: var(--black);
    display: flex; align-items: center;
    padding: 80px 80px 0;
    position: relative; overflow: hidden;
  }
  .hero-bg {
    position: absolute; inset: 0;
    background: 
      radial-gradient(ellipse 60% 80% at 70% 50%, rgba(185,150,90,0.06) 0%, transparent 60%),
      repeating-linear-gradient(
        90deg, transparent, transparent 80px,
        rgba(185,150,90,0.02) 80px, rgba(185,150,90,0.02) 81px
      ),
      repeating-linear-gradient(
        0deg, transparent, transparent 80px,
        rgba(185,150,90,0.02) 80px, rgba(185,150,90,0.02) 81px
      );
  }
  .hero-content { position: relative; z-index: 1; max-width: 680px; }
  .hero-tag {
    display: inline-flex; align-items: center; gap: 12px;
    font-family: var(--font-body); font-size: 10px;
    letter-spacing: 4px; text-transform: uppercase; color: var(--gold);
    margin-bottom: 32px;
  }
  .hero-tag::before { content: ''; width: 32px; height: 1px; background: var(--gold); }
  .hero-title {
    font-family: var(--font-display); font-size: clamp(64px, 9vw, 110px);
    line-height: 0.95; color: var(--white); margin-bottom: 20px;
    font-weight: 300; letter-spacing: 2px;
  }
  .hero-title span { color: var(--gold); display: block; font-style: italic; }
  .hero-sub {
    font-size: 14px; color: rgba(255,255,255,0.5); max-width: 420px;
    line-height: 2; margin-bottom: 48px; font-weight: 300; letter-spacing: 1px;
  }
  .hero-actions { display: flex; gap: 16px; flex-wrap: wrap; }
  .btn-primary {
    font-family: var(--font-body); font-size: 11px; font-weight: 600;
    letter-spacing: 3px; text-transform: uppercase;
    padding: 16px 40px; cursor: pointer;
    background: var(--gold); color: var(--black); border: none;
    transition: all 0.3s;
  }
  .btn-primary:hover { background: var(--gold-light); transform: translateY(-1px); }
  .btn-secondary {
    font-family: var(--font-body); font-size: 11px; font-weight: 600;
    letter-spacing: 3px; text-transform: uppercase;
    padding: 16px 40px; cursor: pointer;
    background: transparent; color: var(--white);
    border: 1px solid rgba(255,255,255,0.25);
    transition: all 0.3s;
  }
  .btn-secondary:hover { border-color: var(--gold); color: var(--gold); }
  .hero-stats {
    position: absolute; right: 80px; bottom: 60px;
    display: flex; gap: 56px;
    border-left: 1px solid rgba(185,150,90,0.2); padding-left: 56px;
  }
  .hero-stat { text-align: right; }
  .hero-stat-num {
    font-family: var(--font-display); font-size: 52px; color: var(--white);
    line-height: 1;
  }
  .hero-stat-label {
    font-size: 12px; color: rgba(255,255,255,0.4);
    text-transform: uppercase; letter-spacing: 2px; font-family: var(--font-mono);
  }
  .hero-line {
    position: absolute; right: 0; top: 64px; bottom: 0; width: 1px;
    background: linear-gradient(to bottom, transparent, var(--accent) 40%, transparent);
    opacity: 0.3;
  }

  /* SECTION */
  .section { padding: 100px 40px; }
  .section-dark { background: var(--black); color: var(--white); }
  .section-light { background: var(--cream); }
  .section-gray { background: #f0ebe3; }
  .section-tag {
    font-family: var(--font-mono); font-size: 11px; letter-spacing: 3px;
    text-transform: uppercase; color: var(--accent); margin-bottom: 12px;
  }
  .section-title {
    font-family: var(--font-display); font-size: clamp(40px, 6vw, 72px);
    line-height: 1; margin-bottom: 24px;
  }
  .section-title.light { color: var(--white); }
  .section-desc { font-size: 16px; color: var(--gray); max-width: 520px; line-height: 1.7; }
  .section-desc.light { color: rgba(255,255,255,0.6); }

  /* ABOUT */
  .about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; max-width: 1200px; margin: 0 auto; }
  .about-numbers { display: grid; grid-template-columns: 1fr 1fr; gap: 2px; margin-top: 48px; }
  .about-num-item {
    background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08);
    padding: 28px 24px;
  }
  .about-num { font-family: var(--font-display); font-size: 48px; color: var(--accent); line-height: 1; }
  .about-num-label { font-size: 12px; color: rgba(255,255,255,0.4); text-transform: uppercase; letter-spacing: 1.5px; margin-top: 4px; }
  .about-right { display: grid; grid-template-columns: 1fr 1fr; gap: 2px; }
  .about-img-block {
    aspect-ratio: 1; background: #1a1a1a;
    display: flex; align-items: center; justify-content: center;
    font-size: 64px; position: relative; overflow: hidden;
  }
  .about-img-block::after {
    content: ''; position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(185,150,90,0.1), transparent);
  }

  /* CATALOG */
  .catalog-header { display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 48px; max-width: 1200px; margin-left: auto; margin-right: auto; }
  .catalog-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 2px; max-width: 1200px; margin: 0 auto; }
  .product-card {
    background: var(--white); border: 1px solid var(--border);
    overflow: hidden; cursor: pointer;
    transition: all 0.4s cubic-bezier(0.25,0.46,0.45,0.94);
    position: relative;
  }
  .product-card:hover { transform: translateY(-6px); box-shadow: 0 32px 64px rgba(0,0,0,0.12); }
  .product-card:hover .product-img img { transform: scale(1.04); }
  .product-img {
    aspect-ratio: 3/4; background: var(--parchment);
    display: flex; align-items: center; justify-content: center;
    font-size: 72px; position: relative; overflow: hidden;
  }
  .product-img img { transition: transform 0.6s cubic-bezier(0.25,0.46,0.45,0.94); }
  .product-badge {
    position: absolute; top: 16px; left: 16px;
    font-family: var(--font-body); font-size: 9px; font-weight: 600;
    letter-spacing: 2.5px; padding: 5px 12px;
    background: var(--gold); color: var(--black); text-transform: uppercase;
  }
  .product-info { padding: 24px; border-top: 1px solid var(--border); }
  .product-name { font-family: var(--font-display); font-size: 24px; margin-bottom: 4px; font-weight: 400; letter-spacing: 1px; }
  .product-fabric { font-size: 11px; color: var(--gray); font-family: var(--font-body); margin-bottom: 16px; letter-spacing: 1.5px; text-transform: uppercase; }
  .product-colors { display: flex; gap: 6px; margin-bottom: 16px; }
  .color-dot {
    width: 16px; height: 16px; border-radius: 50%;
    border: 1px solid var(--border); cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
  }
  .color-dot:hover { transform: scale(1.25); box-shadow: 0 2px 8px rgba(0,0,0,0.15); }
  .product-footer { display: flex; justify-content: space-between; align-items: center; }
  .product-price { font-family: var(--font-display); font-size: 22px; color: var(--gold); font-weight: 400; }
  .product-price-label { font-size: 9px; color: var(--gray); text-transform: uppercase; letter-spacing: 2px; }
  .btn-sm {
    font-family: var(--font-body); font-size: 10px; font-weight: 600;
    letter-spacing: 2px; text-transform: uppercase;
    padding: 10px 20px; cursor: pointer;
    background: var(--black); color: var(--white); border: none;
    transition: all 0.3s;
  }
  .btn-sm:hover { background: var(--gold); color: var(--black); }

  /* PRODUCTION */
  .production-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; max-width: 1200px; margin: 0 auto; }
  .prod-features { display: flex; flex-direction: column; gap: 24px; margin-top: 40px; }
  .prod-feature {
    display: flex; gap: 20px; align-items: flex-start;
    padding: 24px; background: rgba(255,255,255,0.03);
    border-left: 2px solid var(--gold);
  }
  .prod-feature-icon { font-size: 32px; flex-shrink: 0; }
  .prod-feature-title { font-family: var(--font-display); font-size: 20px; color: var(--white); margin-bottom: 4px; }
  .prod-feature-desc { font-size: 14px; color: rgba(255,255,255,0.5); line-height: 1.6; }
  
  /* FORM */
  .form-container {
    background: var(--white); padding: 40px; border: 1px solid var(--border);
  }
  .form-title { font-family: var(--font-display); font-size: 28px; margin-bottom: 24px; }
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
  .form-group { display: flex; flex-direction: column; gap: 6px; margin-bottom: 16px; }
  .form-label { font-size: 11px; font-family: var(--font-mono); text-transform: uppercase; letter-spacing: 1.5px; color: var(--gray); }
  .form-input {
    padding: 12px 16px; border: 1.5px solid var(--border); background: var(--cream);
    font-family: var(--font-body); font-size: 14px; color: var(--black);
    transition: border-color 0.2s; outline: none;
  }
  .form-input:focus { border-color: var(--gold); }
  .form-select {
    padding: 12px 16px; border: 1.5px solid var(--border); background: var(--cream);
    font-family: var(--font-body); font-size: 14px; color: var(--black);
    outline: none; cursor: pointer;
  }
  .form-textarea {
    padding: 12px 16px; border: 1.5px solid var(--border); background: var(--cream);
    font-family: var(--font-body); font-size: 14px; color: var(--black);
    resize: vertical; min-height: 100px; outline: none;
    transition: border-color 0.2s;
  }
  .form-textarea:focus { border-color: var(--gold); }
  .form-full { grid-column: 1 / -1; }

  /* CONTACT */
  .contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; max-width: 1200px; margin: 0 auto; }
  .contact-item { display: flex; gap: 16px; align-items: flex-start; margin-bottom: 28px; }
  .contact-icon { font-size: 24px; }
  .contact-label { font-size: 11px; font-family: var(--font-mono); text-transform: uppercase; letter-spacing: 2px; color: var(--gray); }
  .contact-value { font-size: 16px; font-weight: 500; margin-top: 2px; }

  /* FOOTER */
  .footer {
    background: var(--black); color: rgba(255,255,255,0.35);
    padding: 60px 80px; text-align: center;
    font-size: 11px; font-family: var(--font-body); letter-spacing: 1.5px;
    border-top: 1px solid rgba(185,150,90,0.15);
  }
  .footer-logo { font-family: var(--font-display); font-size: 32px; color: var(--white); margin-bottom: 12px; font-weight: 300; letter-spacing: 6px; }
  .footer-logo span { color: var(--gold); font-style: italic; }
  .footer-divider { width: 40px; height: 1px; background: rgba(185,150,90,0.3); margin: 20px auto; }

  /* MODAL */
  .modal-overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,0.8);
    z-index: 2000; display: flex; align-items: center; justify-content: center;
    padding: 20px; backdrop-filter: blur(4px);
  }
  .modal {
    background: var(--cream); width: 100%; max-width: 480px;
    padding: 56px; position: relative; max-height: 90vh; overflow-y: auto;
    border-top: 3px solid var(--gold);
  }
  .modal-close {
    position: absolute; top: 20px; right: 20px;
    background: none; border: none; font-size: 20px; cursor: pointer;
    color: var(--gray); opacity: 0.6; transition: opacity 0.2s;
  }
  .modal-close:hover { opacity: 1; }
  .modal-title { font-family: var(--font-display); font-size: 40px; margin-bottom: 8px; font-weight: 300; letter-spacing: 2px; }
  .modal-sub { font-size: 12px; color: var(--gray); margin-bottom: 36px; letter-spacing: 1.5px; text-transform: uppercase; }

  /* PORTAL B2B */
  .portal {
    min-height: 100vh; background: #f7f3ed;
    padding-top: 64px;
  }
  .portal-nav {
    background: var(--black);
    padding: 0 40px; height: 56px;
    display: flex; align-items: center; gap: 0;
    position: sticky; top: 64px; z-index: 100;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }
  .portal-tab {
    font-family: var(--font-mono); font-size: 12px; font-weight: 700;
    letter-spacing: 1.5px; text-transform: uppercase;
    padding: 0 24px; height: 100%;
    display: flex; align-items: center;
    color: rgba(255,255,255,0.4); cursor: pointer;
    border: none; background: none;
    border-bottom: 3px solid transparent; margin-bottom: -1px;
    transition: color 0.2s;
  }
  .portal-tab:hover { color: rgba(255,255,255,0.8); }
  .portal-tab.active { color: var(--white); border-bottom-color: var(--accent); }
  .portal-content { padding: 40px; max-width: 1200px; margin: 0 auto; }
  .portal-header { margin-bottom: 32px; }
  .portal-title { font-family: var(--font-display); font-size: 48px; }
  .portal-sub { color: var(--gray); font-size: 14px; margin-top: 4px; }

  /* B2B CATALOG */
  .b2b-product-row {
    background: var(--white); border: 1px solid var(--border);
    display: grid; grid-template-columns: 80px 1fr auto auto auto;
    align-items: center; gap: 24px; padding: 20px;
    margin-bottom: 2px; transition: border-color 0.2s;
  }
  .b2b-product-row:hover { border-color: var(--accent); }
  .b2b-thumb {
    width: 80px; height: 80px; background: #f0ebe3;
    display: flex; align-items: center; justify-content: center;
    font-size: 36px;
  }
  .b2b-name { font-family: var(--font-display); font-size: 20px; }
  .b2b-fabric { font-size: 12px; color: var(--gray); font-family: var(--font-mono); }
  .b2b-price-box { text-align: center; }
  .b2b-price { font-family: var(--font-display); font-size: 24px; color: var(--accent); }
  .b2b-price-type { font-size: 10px; color: var(--gray); text-transform: uppercase; letter-spacing: 1px; font-family: var(--font-mono); }

  /* STOCK TABLE */
  .stock-table { width: 100%; border-collapse: collapse; background: var(--white); }
  .stock-table th {
    background: var(--black); color: var(--white);
    font-family: var(--font-mono); font-size: 11px; letter-spacing: 2px;
    text-transform: uppercase; padding: 12px 16px; text-align: left;
  }
  .stock-table td { padding: 12px 16px; border-bottom: 1px solid var(--border); font-size: 14px; }
  .stock-table tr:hover td { background: #faf6f0; }
  .stock-chip {
    display: inline-block; padding: 2px 10px;
    font-family: var(--font-mono); font-size: 12px; font-weight: 700;
    background: #f0ebe3;
  }
  .stock-chip.low { background: #fee2e2; color: #991b1b; }
  .stock-chip.ok { background: #dcfce7; color: #166534; }

  /* ORDER BUILDER */
  .order-builder { display: grid; grid-template-columns: 1fr 380px; gap: 32px; }
  .order-step {
    background: var(--white); border: 1px solid var(--border); padding: 28px; margin-bottom: 16px;
  }
  .order-step-num {
    font-family: var(--font-display); font-size: 48px; color: var(--border); line-height: 1;
    margin-bottom: 4px;
  }
  .order-step-title { font-family: var(--font-display); font-size: 24px; margin-bottom: 16px; }
  .product-select-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 8px; }
  .product-select-item {
    padding: 12px; border: 2px solid var(--border); cursor: pointer;
    text-align: center; transition: all 0.15s;
    background: var(--cream);
  }
  .product-select-item:hover { border-color: var(--black); }
  .product-select-item.selected { border-color: var(--accent); background: #fff5f3; }
  .product-select-icon { font-size: 32px; margin-bottom: 8px; }
  .product-select-name { font-size: 12px; font-weight: 600; }
  .color-select { display: flex; gap: 10px; flex-wrap: wrap; }
  .color-btn {
    display: flex; align-items: center; gap: 8px;
    padding: 8px 14px; border: 2px solid var(--border);
    cursor: pointer; background: var(--cream); transition: all 0.15s;
    font-size: 13px;
  }
  .color-btn:hover { border-color: var(--black); }
  .color-btn.selected { border-color: var(--accent); background: #fff5f3; }
  .grade-options { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .grade-option {
    padding: 20px; border: 2px solid var(--border); cursor: pointer;
    transition: all 0.15s; background: var(--cream);
  }
  .grade-option:hover { border-color: var(--black); }
  .grade-option.selected { border-color: var(--accent); background: #fff5f3; }
  .grade-option-title { font-family: var(--font-display); font-size: 20px; margin-bottom: 4px; }
  .grade-option-desc { font-size: 12px; color: var(--gray); }
  .grade-option-price { font-size: 14px; color: var(--accent); font-weight: 600; margin-top: 8px; }
  .qty-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 12px; }
  .qty-item { background: var(--cream); border: 1px solid var(--border); padding: 12px; }
  .qty-label { font-family: var(--font-mono); font-size: 11px; letter-spacing: 2px; text-transform: uppercase; color: var(--gray); margin-bottom: 8px; }
  .qty-input {
    width: 100%; padding: 8px; border: 1.5px solid var(--border);
    font-family: var(--font-display); font-size: 28px; text-align: center;
    background: var(--white); outline: none;
  }
  .qty-input:focus { border-color: var(--accent); }

  /* ORDER SUMMARY */
  .order-summary {
    background: var(--black); color: var(--white);
    padding: 28px; position: sticky; top: 124px;
    align-self: start;
  }
  .summary-title { font-family: var(--font-display); font-size: 28px; color: var(--white); margin-bottom: 24px; }
  .summary-row { display: flex; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid rgba(255,255,255,0.08); font-size: 14px; }
  .summary-label { color: rgba(255,255,255,0.5); }
  .summary-value { font-weight: 600; }
  .summary-total { font-family: var(--font-display); font-size: 36px; color: var(--accent); margin-top: 20px; }
  .summary-total-label { font-size: 12px; color: rgba(255,255,255,0.4); text-transform: uppercase; letter-spacing: 2px; font-family: var(--font-mono); }
  @keyframes waPulse {
    0%   { box-shadow: 0 0 0 0 rgba(37,211,102,0.6); }
    70%  { box-shadow: 0 0 0 12px rgba(37,211,102,0); }
    100% { box-shadow: 0 0 0 0 rgba(37,211,102,0); }
  }
  @keyframes waWiggle {
    0%,100% { transform: rotate(0deg); }
    20%     { transform: rotate(-12deg); }
    40%     { transform: rotate(12deg); }
    60%     { transform: rotate(-8deg); }
    80%     { transform: rotate(8deg); }
  }
  .btn-whatsapp {
    display: flex; align-items: center; justify-content: center; gap: 10px;
    width: 100%; padding: 16px;
    background: #25D366; color: var(--white);
    font-family: var(--font-mono); font-size: 13px; font-weight: 700;
    letter-spacing: 1px; text-transform: uppercase;
    border: none; cursor: pointer; margin-top: 20px;
    transition: background 0.2s, transform 0.2s;
    animation: waPulse 2s ease-out infinite;
  }
  .btn-whatsapp:hover {
    background: #1fb855;
    transform: translateY(-2px);
    animation: none;
    box-shadow: 0 8px 24px rgba(37,211,102,0.4);
  }
  .btn-whatsapp:hover svg { animation: waWiggle 0.5s ease; }
  .btn-whatsapp svg { transition: transform 0.2s; }

  /* ADMIN */
  .admin-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 16px; margin-bottom: 40px; }
  .admin-card {
    background: var(--white); border: 1px solid var(--border); padding: 24px;
    border-top: 4px solid var(--accent);
  }
  .admin-card-num { font-family: var(--font-display); font-size: 52px; line-height: 1; }
  .admin-card-label { font-size: 12px; color: var(--gray); text-transform: uppercase; letter-spacing: 2px; font-family: var(--font-mono); }
  .admin-table { width: 100%; border-collapse: collapse; background: var(--white); }
  .admin-table th {
    background: var(--black); color: var(--white);
    font-family: var(--font-mono); font-size: 11px; letter-spacing: 2px;
    text-transform: uppercase; padding: 12px 16px; text-align: left;
  }
  .admin-table td { padding: 12px 16px; border-bottom: 1px solid var(--border); font-size: 14px; }
  .status-badge {
    display: inline-block; padding: 3px 12px;
    font-size: 11px; font-family: var(--font-mono); font-weight: 700;
    text-transform: uppercase; letter-spacing: 1px;
  }
  .status-pending { background: #fef9c3; color: #854d0e; }
  .status-active { background: #dcfce7; color: #166534; }
  .status-rejected { background: #fee2e2; color: #991b1b; }
  
  /* TOAST */
  .toast {
    position: fixed; bottom: 32px; right: 32px; z-index: 9999;
    background: var(--black); color: var(--white);
    padding: 16px 24px; font-family: var(--font-mono); font-size: 13px;
    border-left: 4px solid var(--accent);
    animation: slideIn 0.3s ease;
  }
  @keyframes slideIn { from { transform: translateX(100px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }

  /* ALERT */
  .alert-success {
    background: #dcfce7; border: 1px solid #86efac;
    padding: 16px 20px; font-size: 14px; color: #166534; margin-top: 16px;
    display: flex; align-items: center; gap: 10px;
  }
  .alert-error {
    background: #fee2e2; border: 1px solid #fca5a5;
    padding: 16px 20px; font-size: 14px; color: #991b1b; margin-top: 16px;
  }

  /* UTIL */
  .divider { width: 64px; height: 3px; background: var(--accent); margin-bottom: 24px; }
  .divider.light { background: var(--accent); }
  .tag-strip {
    background: var(--gold); color: var(--black);
    padding: 10px 40px;
    display: flex; gap: 48px; overflow: hidden;
    font-family: var(--font-mono); font-size: 11px; letter-spacing: 3px; text-transform: uppercase;
  }
  .max-w { max-width: 1200px; margin: 0 auto; }

  @media (max-width: 768px) {
    .nav-links { display: none; }
    .hero-stats { display: none; }
    .about-grid, .production-grid, .contact-grid, .order-builder { grid-template-columns: 1fr; }
    .form-grid { grid-template-columns: 1fr; }
    .b2b-product-row { grid-template-columns: 60px 1fr; }
  }
`;

// ─── ICONS ────────────────────────────────────────────────────────────────────

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

// ─── COMPONENTS ───────────────────────────────────────────────────────────────

function Toast({ msg, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, []);
  return <div className="toast">✓ {msg}</div>;
}

function LoginModal({ onClose, onLogin }) {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!email || !pass) { setErr("Preencha e-mail e senha."); return; }
    setLoading(true); setErr("");
    try {
      const { data, error } = await supabase.auth.signInWithPassword({ email, password: pass });
      if (error) { setErr("E-mail ou senha incorretos."); setLoading(false); return; }
      // Fetch profile to get role/status/store info
      const { data: profile } = await supabase.from("profiles").select("*").eq("id", data.user.id).single();
      if (!profile) { setErr("Perfil não encontrado. Entre em contato."); setLoading(false); return; }
      if (profile.status === "pending") { setErr("Cadastro ainda em análise. Aguarde a aprovação."); setLoading(false); return; }
      if (profile.status === "rejected") { setErr("Cadastro não aprovado. Entre em contato."); setLoading(false); return; }
      onLogin({ ...profile, email: data.user.email });
      onClose();
    } catch(e) { setErr("Erro ao conectar. Tente novamente."); setLoading(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title">Entrar</div>
        <div className="modal-sub">Acesso exclusivo para lojistas cadastrados</div>
        <div className="form-group">
          <label className="form-label">E-mail</label>
          <input className="form-input" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" />
        </div>
        <div className="form-group">
          <label className="form-label">Senha</label>
          <input className="form-input" type="password" value={pass} onChange={e => setPass(e.target.value)} placeholder="••••••" onKeyDown={e => e.key === "Enter" && submit()} />
        </div>
        {err && <div className="alert-error">{err}</div>}
        <button className="btn-primary" style={{width:"100%",marginTop:8,opacity:loading?0.7:1}} onClick={submit} disabled={loading}>
          {loading ? "Entrando..." : "Entrar na área B2B"}
        </button>
        <div style={{marginTop:20,textAlign:"center",fontSize:13,color:"var(--gray)"}}>
          Ainda não é lojista?{" "}
          <span style={{color:"var(--gold)",cursor:"pointer",fontWeight:600}} onClick={onClose}>Solicitar cadastro</span>
        </div>
      </div>
    </div>
  );
}

function RegisterModal({ onClose }) {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({ nome:"", loja:"", cnpj:"", tel:"", email:"", cidade:"", instagram:"" });
  const set = k => e => setForm(f => ({...f, [k]: e.target.value}));

  const submit = async () => {
    if (!form.nome || !form.loja || !form.email) { setErr("Preencha os campos obrigatórios."); return; }
    setLoading(true); setErr("");
    try {
      const { error } = await supabase.from("lojista_requests").insert({
        name: form.nome,
        store_name: form.loja,
        cnpj: form.cnpj,
        phone: form.tel,
        email: form.email,
        city: form.cidade,
        instagram: form.instagram,
        status: "pending"
      });
      if (error) throw error;
      setSent(true);
    } catch(e) {
      setErr("Erro ao enviar. Tente novamente ou nos chame no WhatsApp.");
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:560}} onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title">Seja um Lojista</div>
        <div className="modal-sub">Preencha o formulário e entraremos em contato em até 24h</div>
        {sent ? (
          <div className="alert-success">
            ✅ Solicitação enviada! Nossa equipe vai analisar e entrar em contato em breve.
          </div>
        ) : (
          <>
            <div className="form-grid">
              <div className="form-group"><label className="form-label">Seu nome *</label><input className="form-input" value={form.nome} onChange={set("nome")} /></div>
              <div className="form-group"><label className="form-label">Nome da loja *</label><input className="form-input" value={form.loja} onChange={set("loja")} /></div>
              <div className="form-group"><label className="form-label">CNPJ *</label><input className="form-input" value={form.cnpj} onChange={set("cnpj")} placeholder="00.000.000/0001-00" /></div>
              <div className="form-group"><label className="form-label">Telefone *</label><input className="form-input" value={form.tel} onChange={set("tel")} placeholder="(00) 00000-0000" /></div>
              <div className="form-group"><label className="form-label">E-mail *</label><input className="form-input" value={form.email} onChange={set("email")} /></div>
              <div className="form-group"><label className="form-label">Cidade / Estado *</label><input className="form-input" value={form.cidade} onChange={set("cidade")} /></div>
              <div className="form-group form-full"><label className="form-label">Instagram da loja</label><input className="form-input" value={form.instagram} onChange={set("instagram")} placeholder="@sujaloja" /></div>
            </div>
            {err && <div className="alert-error" style={{marginBottom:12}}>{err}</div>}
            <button className="btn-primary" style={{width:"100%",opacity:loading?0.7:1}} onClick={submit} disabled={loading}>
              {loading ? "Enviando..." : "Enviar solicitação"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

// ─── PUBLIC PAGES ─────────────────────────────────────────────────────────────

function HomePage({ setPage }) {
  return (
    <>
      {/* HERO */}
      <section className="hero">
        <div className="hero-bg" />
        <div className="hero-content">
          <div className="hero-tag">Importação Direta da Turquia — Ternos & Vestidos de Noiva</div>
          <h1 className="hero-title">
            DANIEL<span style={{fontStyle:"italic"}}>ABRAHAM.</span>
          </h1>
          <p className="hero-sub">
            Mais de 50 anos trazendo o melhor da alfaiataria turca para o Brasil. Ternos de primeira linha e vestidos de noiva 100% costurados — sem cola, sem compromisso com o inferior.
          </p>
          <div className="hero-actions">
            <button className="btn-primary" onClick={() => setPage("catalog")}>Ver Coleção</button>
            <button className="btn-secondary" onClick={() => setPage("stores")}>Encontrar Loja</button>
            <a href="https://wa.me/5511942600546" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
              <button className="btn-secondary" style={{display:"flex",alignItems:"center",gap:8,borderColor:"#25D366",color:"#25D366"}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                Falar no WhatsApp
              </button>
            </a>
          </div>
        </div>
        <div className="hero-line" />
        <div className="hero-stats">
          <div className="hero-stat"><div className="hero-stat-num">50+</div><div className="hero-stat-label">Anos de tradição</div></div>
          <div className="hero-stat"><div className="hero-stat-num">10+</div><div className="hero-stat-label">Anos em noiva</div></div>
          <div className="hero-stat"><div className="hero-stat-num">3</div><div className="hero-stat-label">Continentes atendidos</div></div>
        </div>
      </section>

      {/* TAG STRIP */}
      <div className="tag-strip">
        {["IMPORTAÇÃO TURQUIA", "TERNOS PRIMEIRA LINHA", "VESTIDOS DE NOIVA", "100% COSTURADO — SEM COLA", "EUROPA & EUA", "ATACADO PARA LOJISTAS", "50 ANOS DE TRADIÇÃO"].map((t,i) => <span key={i}>{t}</span>)}
      </div>

      {/* DOIS MUNDOS */}
      <section className="section" style={{background:"var(--cream)"}}>
        <div className="max-w">
          <div className="section-tag">Nossa coleção</div>
          <h2 className="section-title">DOIS UNIVERSOS<br/><span style={{fontStyle:"italic",color:"var(--gold)"}}>UMA EXCELÊNCIA</span></h2>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:2,marginTop:48}}>
            {/* Ternos */}
            <div onClick={() => setPage("catalog")} style={{background:"var(--black)",padding:"64px 48px",cursor:"pointer",position:"relative",overflow:"hidden",transition:"transform 0.3s"}}
              onMouseEnter={e=>e.currentTarget.style.transform="translateY(-4px)"}
              onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
              <div style={{position:"absolute",top:0,right:0,width:200,height:200,background:"radial-gradient(circle,rgba(185,150,90,0.15),transparent)",pointerEvents:"none"}} />
              <div style={{fontSize:56,marginBottom:24}}>🤵</div>
              <div style={{fontFamily:"var(--font-display)",fontSize:42,color:"var(--white)",lineHeight:1,marginBottom:16,letterSpacing:2}}>TERNOS</div>
              <div style={{fontSize:13,color:"rgba(255,255,255,0.5)",lineHeight:2,marginBottom:32,letterSpacing:0.5}}>
                Importação direta da Turquia. Mais de 50 anos vestindo homens com elegância no Brasil, Europa e Estados Unidos. Tecidos premium, cortes precisos, acabamento impecável.
              </div>
              <div style={{display:"inline-flex",alignItems:"center",gap:8,fontSize:11,color:"var(--gold)",fontFamily:"var(--font-body)",fontWeight:600,letterSpacing:2,textTransform:"uppercase"}}>
                Ver coleção <span>→</span>
              </div>
            </div>
            {/* Noiva */}
            <div onClick={() => setPage("catalog")} style={{background:"var(--parchment)",padding:"64px 48px",cursor:"pointer",position:"relative",overflow:"hidden",transition:"transform 0.3s"}}
              onMouseEnter={e=>e.currentTarget.style.transform="translateY(-4px)"}
              onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
              <div style={{position:"absolute",top:0,right:0,width:200,height:200,background:"radial-gradient(circle,rgba(185,150,90,0.1),transparent)",pointerEvents:"none"}} />
              <div style={{fontSize:56,marginBottom:24}}>👗</div>
              <div style={{fontFamily:"var(--font-display)",fontSize:42,color:"var(--black)",lineHeight:1,marginBottom:16,letterSpacing:2,fontStyle:"italic"}}>NOIVA</div>
              <div style={{fontSize:13,color:"var(--gray)",lineHeight:2,marginBottom:32,letterSpacing:0.5}}>
                Mais de 10 anos criando vestidos de noiva de primeira linha. Peças 100% costuradas — sem cola em nenhuma parte. Trabalhamos com Europa e Brasil, sempre com o mais alto padrão.
              </div>
              <div style={{display:"inline-flex",alignItems:"center",gap:8,fontSize:11,color:"var(--black)",fontFamily:"var(--font-body)",fontWeight:600,letterSpacing:2,textTransform:"uppercase"}}>
                Ver coleção <span>→</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DIFERENCIAIS */}
      <section className="section section-dark">
        <div className="max-w">
          <div className="section-tag">Por que nos escolher</div>
          <h2 className="section-title light">O QUE NOS<br/><span style={{fontStyle:"italic",color:"var(--gold)"}}>DIFERENCIA</span></h2>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:1,marginTop:48}}>
            {[
              {icon:"✈️", title:"Importação Direta", desc:"Trazemos ternos diretamente da Turquia, eliminando intermediários e garantindo o melhor preço com a mais alta qualidade."},
              {icon:"🧵", title:"100% Costurado", desc:"Nenhuma peça nossa usa cola. Cada vestido de noiva é inteiramente costurado, garantindo durabilidade e elegância real."},
              {icon:"🌍", title:"Presença Global", desc:"Nossos produtos já vestiram pessoas no Brasil, Europa e Estados Unidos. Uma tradição reconhecida internacionalmente."},
              {icon:"👑", title:"Primeira Linha", desc:"Trabalhamos somente com materiais de primeira linha. Sem concessões, sem segunda escolha — apenas o melhor."},
            ].map((item,i) => (
              <div key={i} style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(185,150,90,0.15)",padding:36,borderTop:`2px solid ${i===0||i===2?"var(--gold)":"transparent"}`}}>
                <div style={{fontSize:36,marginBottom:20}}>{item.icon}</div>
                <div style={{fontFamily:"var(--font-display)",fontSize:24,color:"var(--white)",marginBottom:12,letterSpacing:1}}>{item.title}</div>
                <div style={{fontSize:13,color:"rgba(255,255,255,0.45)",lineHeight:2,letterSpacing:0.3}}>{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA — ENCONTRE UMA LOJA */}
      <section style={{background:"var(--gold)",padding:"100px 80px",textAlign:"center"}}>
        <div className="max-w">
          <div style={{fontFamily:"var(--font-body)",fontSize:10,letterSpacing:4,textTransform:"uppercase",color:"rgba(10,10,15,0.6)",marginBottom:20}}>
            Encontre perto de você
          </div>
          <h2 style={{fontFamily:"var(--font-display)",fontSize:"clamp(40px,6vw,80px)",color:"var(--black)",lineHeight:0.95,marginBottom:24,fontWeight:300,letterSpacing:2}}>
            ENCONTRE UMA<br/><span style={{fontStyle:"italic"}}>LOJA PARCEIRA</span>
          </h2>
          <p style={{fontSize:14,color:"rgba(10,10,15,0.6)",maxWidth:480,margin:"0 auto 48px",lineHeight:2,letterSpacing:0.5}}>
            Nossos produtos estão disponíveis em lojas selecionadas em todo o Brasil. Encontre a mais próxima de você.
          </p>
          <button className="btn-primary" style={{background:"var(--black)",color:"var(--white)"}} onClick={() => setPage("stores")}>
            Ver lojas no mapa →
          </button>
        </div>
      </section>
    </>
  );
}

function ProductCard({ p, setPage, onOpenProduct }) {
  const [selColor, setSelColor] = useState(p.colors?.[0] || null);
  const colorPhoto = p.photos?.[selColor] || null;
  const photo = colorPhoto || (p.mainPhotos&&p.mainPhotos[0]) || null;
  return (
    <div className="product-card" key={p.id} style={{cursor:"pointer"}} onClick={() => onOpenProduct && onOpenProduct(p, selColor)}>
      <div className="product-img" style={{position:"relative",background:"var(--parchment)",overflow:"hidden"}}>
        {photo
          ? <img src={photo} alt={p.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}} />
          : <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%",fontSize:64,color:"rgba(0,0,0,0.1)"}}>🧥</div>
        }
        {p.badge && <div className="product-badge">{p.badge}</div>}
      </div>
      <div className="product-info">
        <div className="product-name">{p.name}</div>
        <div className="product-fabric">{p.fabric}</div>
        <div style={{fontSize:11,color:"var(--gray)",marginBottom:12,letterSpacing:1}}>
          Tamanhos: {(p.sizes||[]).join(" · ")}
        </div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
          {(p.colors||[]).map(c => (
            <div key={c} onClick={e=>{e.stopPropagation();setSelColor(c);}}
              title={c}
              style={{width:20,height:20,borderRadius:"50%",background:COLOR_HEX[c]||"#888",
                border: selColor===c ? "2px solid var(--gold)" : "1px solid #ddd",
                cursor:"pointer",flexShrink:0,transition:"all 0.2s"}} />
          ))}
        </div>
        {selColor && <div style={{fontSize:11,color:"var(--gray)",marginBottom:8,letterSpacing:0.5}}>{selColor}</div>}
        <div style={{borderTop:"1px solid var(--border)",paddingTop:16,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div className="product-price-label">Disponível nas lojas parceiras</div>
          </div>
          <button className="btn-sm" onClick={e=>{e.stopPropagation();setPage&&setPage("stores");}}>Ver lojas →</button>
        </div>
      </div>
    </div>
  );
}

function ProductDetailModal({ product, initialColor, onClose, setPage }) {
  const [selColor, setSelColor] = useState(initialColor || product.colors?.[0] || null);
  const [photoIdx, setPhotoIdx] = useState(0);
  const mainPhotos = product.mainPhotos || (product.main_photos) || [];
  const colorPhoto = product.photos?.[selColor] || null;
  // Display: color photo first, then gallery of main photos
  const allPhotos = colorPhoto
    ? [colorPhoto, ...mainPhotos.filter(p => p !== colorPhoto)]
    : mainPhotos;
  const displayPhoto = allPhotos[photoIdx] || null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div style={{background:"var(--white)",maxWidth:900,width:"94%",maxHeight:"92vh",overflow:"auto",display:"grid",gridTemplateColumns:"1fr 1fr"}} onClick={e=>e.stopPropagation()}>
        {/* LEFT: photo + thumbnails */}
        <div style={{background:"var(--parchment)",display:"flex",flexDirection:"column",position:"relative"}}>
          {/* Main display */}
          <div style={{flex:1,minHeight:360,position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}}>
            {displayPhoto
              ? <img src={displayPhoto} alt={product.name} style={{width:"100%",height:"100%",objectFit:"cover",position:"absolute",inset:0}} />
              : <div style={{fontSize:96,opacity:0.15}}>🧥</div>}
            <button onClick={onClose} style={{position:"absolute",top:12,right:12,background:"rgba(0,0,0,0.5)",color:"#fff",border:"none",width:32,height:32,cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
          </div>
          {/* Thumbnails */}
          {allPhotos.length > 1 && (
            <div style={{display:"flex",gap:4,padding:8,background:"rgba(0,0,0,0.04)"}}>
              {allPhotos.map((p,i) => (
                <div key={i} onClick={()=>setPhotoIdx(i)}
                  style={{width:52,height:64,flexShrink:0,cursor:"pointer",overflow:"hidden",border: photoIdx===i ? "2px solid var(--gold)" : "2px solid transparent",opacity: photoIdx===i ? 1 : 0.6,transition:"all 0.2s"}}>
                  <img src={p} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}} />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* RIGHT: info */}
        <div style={{padding:40,overflowY:"auto"}}>
          {product.badge && <span style={{fontSize:10,background:"var(--gold)",color:"var(--black)",padding:"3px 10px",fontFamily:"var(--font-body)",letterSpacing:2,textTransform:"uppercase"}}>{product.badge}</span>}
          <div style={{fontFamily:"var(--font-display)",fontSize:34,marginTop:12,lineHeight:1,letterSpacing:1}}>{product.name}</div>
          {product.fabric && <div style={{fontSize:12,color:"var(--gray)",marginTop:6,marginBottom:4,letterSpacing:1,textTransform:"uppercase"}}>{product.fabric}</div>}
          {(product.tipo||product.modelo) && <div style={{fontSize:12,color:"var(--gold)",marginBottom:16,letterSpacing:1}}>{[product.tipo,product.modelo].filter(Boolean).join(" · ")}</div>}
          {product.desc && <p style={{fontSize:13,color:"var(--gray)",lineHeight:1.9,marginBottom:20,borderTop:"1px solid var(--border)",paddingTop:16}}>{product.desc}</p>}

          {/* Colors */}
          {product.colors?.length > 0 && (
            <>
              <div style={{fontSize:10,color:"var(--gray)",letterSpacing:2,textTransform:"uppercase",marginBottom:8}}>Cor: <strong style={{color:"var(--black)"}}>{selColor}</strong></div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:20}}>
                {product.colors.map(c => (
                  <div key={c} onClick={()=>{setSelColor(c);setPhotoIdx(0);}} title={c}
                    style={{width:26,height:26,borderRadius:"50%",background:COLOR_HEX[c]||"#888",
                      border: selColor===c?"3px solid var(--gold)":"2px solid #ddd",
                      cursor:"pointer",transition:"all 0.15s"}} />
                ))}
              </div>
            </>
          )}

          {/* Sizes */}
          {product.sizes?.length > 0 && (
            <>
              <div style={{fontSize:10,color:"var(--gray)",letterSpacing:2,textTransform:"uppercase",marginBottom:8}}>Tamanhos disponíveis</div>
              <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:24}}>
                {product.sizes.map(s=>(
                  <div key={s} style={{padding:"6px 12px",border:"1px solid var(--border)",fontFamily:"var(--font-body)",fontSize:12,fontWeight:600,letterSpacing:0.5}}>{s}</div>
                ))}
              </div>
            </>
          )}

          <div style={{background:"var(--parchment)",padding:20,marginBottom:20,borderLeft:"3px solid var(--gold)"}}>
            <div style={{fontSize:10,color:"var(--gray)",marginBottom:6,letterSpacing:1,textTransform:"uppercase"}}>Onde encontrar</div>
            <div style={{fontFamily:"var(--font-display)",fontSize:18,letterSpacing:1}}>Disponível nas lojas parceiras em todo o Brasil</div>
          </div>

          <button className="btn-primary" style={{width:"100%",marginBottom:10}} onClick={()=>setPage("stores")}>
            Encontrar loja perto de mim →
          </button>
          <a href="https://wa.me/5511942600546" target="_blank" rel="noreferrer" style={{textDecoration:"none",display:"block"}}>
            <button style={{width:"100%",padding:"14px",background:"#25D366",color:"#fff",border:"none",cursor:"pointer",fontFamily:"var(--font-body)",fontSize:11,fontWeight:600,letterSpacing:2,textTransform:"uppercase"}}>
              Falar com a fábrica no WhatsApp
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

function CatalogPage({ setPage }) {
  const [filter, setFilter] = useState("Todos");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openProduct, setOpenProduct] = useState(null);
  const [openColor, setOpenColor] = useState(null);

  useEffect(() => {
    setLoading(true);
    supabase.from("products").select("*").eq("active", true).then(({ data }) => {
      if (data && data.length > 0) {
        setProducts(data.map(p => ({
          ...p, group: p.group_name, tipo: p.tipo || p.group_name, modelo: p.modelo || "",
          mainPhotos: p.main_photos||(p.main_photo?[p.main_photo]:[]), desc: p.description, photos: p.photos || {}, stock: {}
        })));
      }
      setLoading(false);
    });
  }, []);

  const tipos = ["Todos", ...Array.from(new Set(products.map(p => p.tipo || p.group_name).filter(Boolean)))];
  const modelos = ["Todos", ...Array.from(new Set(products.map(p => p.modelo).filter(Boolean)))];
  const [filterModelo, setFilterModelo] = useState("Todos");
  const filtered = products.filter(p =>
    p.active !== false &&
    (filter === "Todos" || (p.tipo || p.group_name) === filter) &&
    (filterModelo === "Todos" || p.modelo === filterModelo)
  );

  return (
    <div style={{paddingTop:72,minHeight:"100vh",background:"var(--cream)"}}>
      <div style={{background:"var(--black)",padding:"80px 80px 60px",borderBottom:"1px solid rgba(185,150,90,0.15)"}}>
        <div className="section-tag">Coleção</div>
        <h1 style={{fontFamily:"var(--font-display)",fontSize:"clamp(56px,8vw,100px)",color:"var(--white)",lineHeight:0.95,fontWeight:300,letterSpacing:2}}>
          COLEÇÃO<br/><span style={{color:"var(--gold)",fontStyle:"italic"}}>EXCLUSIVA</span>
        </h1>
        <p style={{color:"rgba(255,255,255,0.45)",marginTop:24,fontSize:13,letterSpacing:1,lineHeight:2,maxWidth:480}}>
          Ternos e trajes de alta qualidade. Encontre um lojista parceiro na sua cidade para adquirir.
        </p>
        <button onClick={() => setPage("stores")} style={{marginTop:32,display:"inline-flex",alignItems:"center",gap:12,fontFamily:"var(--font-body)",fontSize:11,fontWeight:600,letterSpacing:3,textTransform:"uppercase",background:"var(--gold)",color:"var(--black)",border:"none",padding:"14px 32px",cursor:"pointer"}}>
          Encontrar loja perto de mim →
        </button>
      </div>

      <div style={{padding:"48px 80px",maxWidth:1400,margin:"0 auto"}}>
        {/* Filtro por Tipo */}
        <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
          {tipos.map(f => (
            <button key={f} onClick={() => setFilter(f)}
              style={{fontFamily:"var(--font-body)",fontSize:10,letterSpacing:2,textTransform:"uppercase",
                padding:"9px 20px",cursor:"pointer",border:"1px solid",transition:"all 0.3s",
                borderColor: filter===f ? "var(--gold)" : "var(--border)",
                background: filter===f ? "var(--gold)" : "transparent",
                color: filter===f ? "var(--black)" : "var(--gray)"}}>
              {f}{f !== "Todos" && ` (${products.filter(p=>(p.tipo||p.group_name)===f).length})`}
            </button>
          ))}
        </div>
        {/* Filtro por Modelo */}
        {modelos.length > 1 && (
          <div style={{display:"flex",gap:8,marginBottom:32,flexWrap:"wrap",paddingLeft:8,borderLeft:"2px solid var(--border)"}}>
            <span style={{fontSize:10,color:"var(--gray)",letterSpacing:1.5,textTransform:"uppercase",alignSelf:"center",marginRight:4}}>Modelo:</span>
            {modelos.map(f => (
              <button key={f} onClick={() => setFilterModelo(f)}
                style={{fontFamily:"var(--font-body)",fontSize:10,letterSpacing:1.5,textTransform:"uppercase",
                  padding:"7px 16px",cursor:"pointer",border:"1px solid",transition:"all 0.3s",
                  borderColor: filterModelo===f ? "var(--black)" : "var(--border)",
                  background: filterModelo===f ? "var(--black)" : "transparent",
                  color: filterModelo===f ? "var(--white)" : "var(--gray)"}}>
                {f}
              </button>
            ))}
          </div>
        )}
        {loading && <div style={{textAlign:"center",padding:"80px 0",fontFamily:"var(--font-display)",fontSize:32,color:"var(--gray)",letterSpacing:2}}>Carregando coleção...</div>}
        {!loading && filtered.length === 0 && <div style={{textAlign:"center",padding:"80px 0",fontFamily:"var(--font-display)",fontSize:28,color:"var(--gray)",letterSpacing:2}}>Coleção em breve.</div>}
        <div className="catalog-grid">
          {filtered.map(p => (
            <ProductCard key={p.id} p={p} setPage={setPage} onOpenProduct={(prod,color)=>{setOpenProduct(prod);setOpenColor(color);}} />
          ))}
        </div>
      </div>

      {openProduct && (
        <ProductDetailModal product={openProduct} initialColor={openColor} onClose={() => setOpenProduct(null)} setPage={setPage} />
      )}
    </div>
  );
}


function StoreFormModal({ store, onSave, onClose }) {
  const isEdit = !!store;
  const empty = { name:"", cep:"", address:"", number:"", complement:"", neighborhood:"", city:"", state:"", whatsapp:"", instagram:"", website:"", active:true };
  const [form, setForm] = useState(isEdit ? {...store, number:store.number||"", complement:store.complement||"", neighborhood:store.neighborhood||"", cep:store.cep||""} : empty);
  const [saving, setSaving] = useState(false);
  const [cepLoading, setCepLoading] = useState(false);
  const [cepError, setCepError] = useState("");
  const [error, setError] = useState("");
  const setE = k => e => setForm(f=>({...f,[k]:e.target.value}));
  const inp = {padding:"10px 14px",border:"1px solid var(--border)",background:"var(--cream)",fontFamily:"var(--font-body)",fontSize:14,color:"var(--black)",outline:"none",width:"100%"};
  const lbl = {fontSize:10,fontFamily:"var(--font-body)",textTransform:"uppercase",letterSpacing:"2px",color:"var(--gray)",marginBottom:6,display:"block"};

  const buscarCep = async () => {
    const cep = form.cep.replace(/\D/g,"");
    if (cep.length !== 8) { setCepError("CEP deve ter 8 dígitos."); return; }
    setCepLoading(true); setCepError("");
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await res.json();
      if (data.erro) { setCepError("CEP não encontrado."); }
      else {
        setForm(f => ({...f,
          address: data.logradouro || f.address,
          neighborhood: data.bairro || f.neighborhood,
          city: data.localidade || f.city,
          state: data.uf || f.state,
        }));
      }
    } catch { setCepError("Erro ao buscar CEP."); }
    setCepLoading(false);
  };

  const save = async () => {
    if (!form.name.trim()) { setError("Nome obrigatório."); return; }
    if (!form.address.trim()) { setError("Endereço obrigatório."); return; }
    if (!form.city.trim()) { setError("Cidade obrigatória."); return; }
    if (!form.state.trim()) { setError("Estado obrigatório."); return; }
    setSaving(true);
    const fullAddress = `${form.address}${form.number ? ", "+form.number : ""}${form.complement ? " "+form.complement : ""}${form.neighborhood ? " — "+form.neighborhood : ""}`;
    const payload = { name:form.name, cep:form.cep, address:fullAddress, number:form.number, complement:form.complement, neighborhood:form.neighborhood, city:form.city, state:form.state, whatsapp:form.whatsapp, instagram:form.instagram, website:form.website, active:form.active !== false };
    if (isEdit) {
      const { data } = await supabase.from("stores").update(payload).eq("id", store.id).select().single();
      onSave(data || {...form, id:store.id});
    } else {
      const { data } = await supabase.from("stores").insert(payload).select().single();
      onSave(data || {...form, id:Date.now().toString()});
    }
    setSaving(false);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:600,padding:48,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title">{isEdit?"Editar Loja":"Nova Loja"}</div>
        <div className="modal-sub">{isEdit?`Editando: ${store.name}`:"Cadastrar loja parceira"}</div>

        <div style={{marginBottom:20}}><label style={lbl}>Nome da loja *</label><input style={inp} value={form.name} onChange={setE("name")} placeholder="Ex: Boutique Elegance" /></div>

        {/* CEP SEARCH */}
        <div style={{marginBottom:8}}>
          <label style={lbl}>CEP</label>
          <div style={{display:"flex",gap:8}}>
            <input style={{...inp,flex:1}} value={form.cep} onChange={setE("cep")}
              placeholder="00000-000" maxLength={9}
              onKeyDown={e=>e.key==="Enter"&&buscarCep()}
              onBlur={()=>form.cep.replace(/\D/g,"").length===8&&buscarCep()}
            />
            <button onClick={buscarCep} disabled={cepLoading}
              style={{padding:"10px 20px",background:"var(--black)",color:"var(--white)",border:"none",cursor:"pointer",fontFamily:"var(--font-body)",fontSize:11,letterSpacing:1,whiteSpace:"nowrap",opacity:cepLoading?0.6:1}}>
              {cepLoading ? "Buscando..." : "Buscar CEP"}
            </button>
          </div>
          {cepError && <div style={{fontSize:12,color:"#dc2626",marginTop:4}}>{cepError}</div>}
        </div>

        <div style={{marginBottom:12}}><label style={lbl}>Rua / Logradouro *</label><input style={inp} value={form.address} onChange={setE("address")} placeholder="Preenchido automaticamente pelo CEP" /></div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:12,marginBottom:12}}>
          <div><label style={lbl}>Número</label><input style={inp} value={form.number} onChange={setE("number")} placeholder="123" /></div>
          <div><label style={lbl}>Complemento</label><input style={inp} value={form.complement} onChange={setE("complement")} placeholder="Sala 2, Andar 3..." /></div>
        </div>
        <div style={{marginBottom:12}}><label style={lbl}>Bairro</label><input style={inp} value={form.neighborhood} onChange={setE("neighborhood")} /></div>
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:12,marginBottom:20}}>
          <div><label style={lbl}>Cidade *</label><input style={inp} value={form.city} onChange={setE("city")} /></div>
          <div><label style={lbl}>UF *</label><input style={inp} value={form.state} onChange={setE("state")} placeholder="SP" maxLength={2} style={{...inp,textTransform:"uppercase"}} /></div>
        </div>

        <div style={{height:1,background:"var(--border)",marginBottom:20}} />

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
          <div><label style={lbl}>WhatsApp</label><input style={inp} value={form.whatsapp} onChange={setE("whatsapp")} placeholder="(11) 99999-9999" /></div>
          <div><label style={lbl}>Instagram</label><input style={inp} value={form.instagram} onChange={setE("instagram")} placeholder="@nomedaloja" /></div>
        </div>
        <div style={{marginBottom:20}}><label style={lbl}>Site</label><input style={inp} value={form.website} onChange={setE("website")} placeholder="https://..." /></div>

        <div style={{marginBottom:24,display:"flex",alignItems:"center",gap:12}}>
          <input type="checkbox" id="storeActive" checked={form.active !== false} onChange={e=>setForm(f=>({...f,active:e.target.checked}))} style={{width:18,height:18,cursor:"pointer",accentColor:"var(--gold)"}} />
          <label htmlFor="storeActive" style={{fontFamily:"var(--font-body)",fontSize:13,cursor:"pointer"}}>Loja ativa (visível no site)</label>
        </div>

        {error && <div style={{color:"#dc2626",fontSize:13,marginBottom:16,padding:"10px 14px",background:"#fef2f2",border:"1px solid #fecaca"}}>{error}</div>}
        <div style={{display:"flex",gap:12,justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{padding:"12px 28px",border:"1px solid var(--border)",background:"transparent",cursor:"pointer",fontFamily:"var(--font-body)",fontSize:12,letterSpacing:1}}>Cancelar</button>
          <button className="btn-primary" onClick={save} disabled={saving}>{saving?"Salvando...":isEdit?"Salvar alterações":"Cadastrar loja"}</button>
        </div>
      </div>
    </div>
  );
}


function StoresPage() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    supabase.from("stores").select("*").eq("active", true).order("name").then(({ data }) => {
      if (data) setStores(data);
      setLoading(false);
    });
  }, []);

  const filtered = stores.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.city.toLowerCase().includes(search.toLowerCase()) ||
    s.state.toLowerCase().includes(search.toLowerCase())
  );

  const mapUrl = selected
    ? `https://www.google.com/maps?q=${encodeURIComponent(selected.address + ", " + selected.city + ", " + selected.state)}&output=embed`
    : stores.length > 0
      ? `https://www.google.com/maps?q=${encodeURIComponent(stores[0].address + ", " + stores[0].city)}&output=embed`
      : `https://www.google.com/maps?q=São+Paulo,+SP,+Brasil&output=embed`;

  return (
    <div style={{paddingTop:72,minHeight:"100vh",background:"var(--cream)"}}>
      {/* Header */}
      <div style={{background:"var(--black)",padding:"80px 80px 60px",borderBottom:"1px solid rgba(185,150,90,0.15)"}}>
        <div className="section-tag">Lojas Parceiras</div>
        <h1 style={{fontFamily:"var(--font-display)",fontSize:"clamp(48px,7vw,90px)",color:"var(--white)",lineHeight:0.95,fontWeight:300,letterSpacing:2}}>
          ENCONTRE<br/><span style={{color:"var(--gold)",fontStyle:"italic"}}>SUA LOJA</span>
        </h1>
        <p style={{color:"rgba(255,255,255,0.45)",marginTop:24,fontSize:13,letterSpacing:1,lineHeight:2,maxWidth:480}}>
          Nossos ternos estão disponíveis em lojas parceiras selecionadas em todo o Brasil.
        </p>
      </div>

      {/* Content */}
      <div style={{display:"grid",gridTemplateColumns:"380px 1fr",minHeight:"calc(100vh - 72px - 260px)"}}>
        
        {/* LEFT: list */}
        <div style={{borderRight:"1px solid var(--border)",display:"flex",flexDirection:"column"}}>
          {/* Search */}
          <div style={{padding:"24px",borderBottom:"1px solid var(--border)"}}>
            <input
              value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="Buscar por cidade ou loja..."
              style={{width:"100%",padding:"12px 16px",border:"1px solid var(--border)",background:"white",fontFamily:"var(--font-body)",fontSize:13,outline:"none",letterSpacing:0.5}}
            />
          </div>
          {/* Store list */}
          <div style={{flex:1,overflowY:"auto"}}>
            {loading && (
              <div style={{padding:40,textAlign:"center",fontFamily:"var(--font-display)",fontSize:24,color:"var(--gray)"}}>Carregando...</div>
            )}
            {!loading && filtered.length === 0 && (
              <div style={{padding:40,textAlign:"center",color:"var(--gray)",fontFamily:"var(--font-body)",fontSize:13,letterSpacing:1}}>
                {stores.length === 0 ? "Em breve lojas parceiras na sua cidade." : "Nenhuma loja encontrada."}
              </div>
            )}
            {filtered.map(s => (
              <div key={s.id} onClick={() => setSelected(s)}
                style={{padding:"24px",borderBottom:"1px solid var(--border)",cursor:"pointer",transition:"all 0.2s",
                  background: selected?.id===s.id ? "var(--parchment)" : "white",
                  borderLeft: selected?.id===s.id ? "3px solid var(--gold)" : "3px solid transparent"}}>
                <div style={{fontFamily:"var(--font-display)",fontSize:20,letterSpacing:1,marginBottom:4}}>{s.name}</div>
                <div style={{fontSize:12,color:"var(--gray)",marginBottom:12,letterSpacing:0.5,lineHeight:1.6}}>
                  📍 {s.address}<br/>{s.city} — {s.state}
                </div>
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  {s.whatsapp && (
                    <a href={`https://wa.me/55${s.whatsapp.replace(/\D/g,"")}`} target="_blank" rel="noreferrer"
                      onClick={e=>e.stopPropagation()}
                      style={{textDecoration:"none",display:"inline-flex",alignItems:"center",gap:6,padding:"6px 14px",background:"#25D366",color:"white",fontSize:11,fontFamily:"var(--font-body)",fontWeight:600,letterSpacing:1}}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                      WhatsApp
                    </a>
                  )}
                  {s.instagram && (
                    <a href={s.instagram.startsWith("http") ? s.instagram : `https://instagram.com/${s.instagram.replace("@","")}`}
                      target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()}
                      style={{textDecoration:"none",display:"inline-flex",alignItems:"center",gap:6,padding:"6px 14px",background:"var(--black)",color:"white",fontSize:11,fontFamily:"var(--font-body)",fontWeight:600,letterSpacing:1}}>
                      Instagram
                    </a>
                  )}
                  {s.website && (
                    <a href={s.website} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()}
                      style={{textDecoration:"none",display:"inline-flex",alignItems:"center",gap:6,padding:"6px 14px",border:"1px solid var(--border)",color:"var(--gray)",fontSize:11,fontFamily:"var(--font-body)",letterSpacing:1}}>
                      Site
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: Google Maps */}
        <div style={{position:"relative",minHeight:500}}>
          <iframe
            key={selected?.id || "default"}
            title="Mapa de lojas"
            src={mapUrl}
            width="100%" height="100%"
            style={{border:0,display:"block",minHeight:500}}
            allowFullScreen loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          {selected && (
            <div style={{position:"absolute",bottom:24,left:24,background:"white",padding:"16px 20px",boxShadow:"0 8px 32px rgba(0,0,0,0.15)",borderTop:"3px solid var(--gold)",maxWidth:280}}>
              <div style={{fontFamily:"var(--font-display)",fontSize:18,letterSpacing:1,marginBottom:4}}>{selected.name}</div>
              <div style={{fontSize:12,color:"var(--gray)",lineHeight:1.7}}>{selected.address}<br/>{selected.city} — {selected.state}</div>
              <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selected.address+", "+selected.city+", "+selected.state)}`}
                target="_blank" rel="noreferrer"
                style={{display:"inline-block",marginTop:10,fontSize:11,color:"var(--gold)",textDecoration:"none",letterSpacing:1,fontFamily:"var(--font-body)",fontWeight:600}}>
                Abrir no Google Maps →
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function AboutPage() {
  return (
    <div style={{paddingTop:72,minHeight:"100vh"}}>
      {/* HERO */}
      <section className="section section-dark" style={{padding:"100px 80px"}}>
        <div className="max-w">
          <div className="section-tag">Sobre nós</div>
          <h1 className="section-title light">MAIS DE 50 ANOS<br/><span style={{fontStyle:"italic",color:"var(--gold)"}}>DE TRADIÇÃO</span></h1>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:80,marginTop:48,alignItems:"start"}}>
            <div>
              <p style={{fontSize:16,color:"rgba(255,255,255,0.65)",lineHeight:2.2,marginBottom:32,letterSpacing:0.3}}>
                A Daniel Abraham é uma das casas mais tradicionais na importação de ternos de primeira linha da Turquia para o Brasil. Com mais de 50 anos de história, já vestimos homens no Brasil, na Europa e nos Estados Unidos — sempre com o padrão mais alto de qualidade e elegância.
              </p>
              <p style={{fontSize:16,color:"rgba(255,255,255,0.65)",lineHeight:2.2,letterSpacing:0.3}}>
                Há mais de 10 anos, expandimos nossa atuação para o universo nupcial. Nossos vestidos de noiva são peças de primeira linha, trabalhadas com o mesmo rigor da alfaiataria: nenhum vestido leva cola — tudo é 100% costurado. Uma distinção que separa a alta costura do produto comum.
              </p>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:1}}>
              {[
                {n:"50+", l:"Anos de tradição em ternos"},
                {n:"10+", l:"Anos em vestidos de noiva"},
                {n:"3",   l:"Continentes atendidos"},
                {n:"100%",l:"Costurado — sem cola"},
              ].map(({n,l}) => (
                <div key={l} style={{padding:"36px 28px",background:"rgba(255,255,255,0.03)",border:"1px solid rgba(185,150,90,0.15)"}}>
                  <div style={{fontFamily:"var(--font-display)",fontSize:52,color:"var(--gold)",lineHeight:1,marginBottom:8,fontWeight:300}}>{n}</div>
                  <div style={{fontSize:12,color:"rgba(255,255,255,0.4)",letterSpacing:1.5,textTransform:"uppercase",lineHeight:1.6}}>{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* TERNOS */}
      <section className="section" style={{background:"var(--cream)",padding:"100px 80px"}}>
        <div className="max-w">
          <div className="section-tag">Ternos</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:80,alignItems:"center"}}>
            <div>
              <h2 className="section-title">A ARTE DA<br/><span style={{fontStyle:"italic",color:"var(--gold)"}}>ALFAIATARIA TURCA</span></h2>
              <p style={{fontSize:14,color:"var(--gray)",lineHeight:2.2,marginBottom:24,letterSpacing:0.3}}>
                A Turquia é reconhecida mundialmente pela excelência em alfaiataria masculina. Trabalhamos diretamente com os melhores fabricantes turcos, trazendo para o Brasil ternos que normalmente só se encontram nas melhores casas da Europa.
              </p>
              <p style={{fontSize:14,color:"var(--gray)",lineHeight:2.2,letterSpacing:0.3}}>
                Tecidos de lã, linho e misturas premium. Cortes modernos e clássicos. Acabamento que resiste ao tempo. É o que você encontra na Daniel Abraham.
              </p>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:1}}>
              {[
                {icon:"✈️", t:"Importação Direta da Turquia", d:"Sem intermediários. Negociamos diretamente com os fabricantes turcos para garantir qualidade e preço."},
                {icon:"🌍", t:"Presença Internacional", d:"Distribuição no Brasil, Europa e Estados Unidos. Um padrão reconhecido em três continentes."},
                {icon:"🧵", t:"Tecidos Premium", d:"Lã merino, linho italiano e misturas exclusivas. Cada terno é feito para durar décadas."},
              ].map((item,i) => (
                <div key={i} style={{padding:"28px 32px",background:"var(--white)",border:"1px solid var(--border)",borderLeft:"3px solid var(--gold)",display:"flex",gap:20,alignItems:"flex-start"}}>
                  <div style={{fontSize:28,flexShrink:0}}>{item.icon}</div>
                  <div>
                    <div style={{fontFamily:"var(--font-display)",fontSize:20,marginBottom:6,letterSpacing:1}}>{item.t}</div>
                    <div style={{fontSize:13,color:"var(--gray)",lineHeight:1.8}}>{item.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NOIVA */}
      <section className="section section-dark" style={{padding:"100px 80px"}}>
        <div className="max-w">
          <div className="section-tag">Vestidos de Noiva</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:80,alignItems:"center"}}>
            <div style={{display:"flex",flexDirection:"column",gap:1}}>
              {[
                {icon:"💍", t:"100% Costurado — Sem Cola", d:"Nenhuma parte do nosso vestido usa cola. Cada detalhe é costurado à mão ou à máquina com rigor absoluto."},
                {icon:"👗", t:"Primeira Linha", d:"Trabalhamos somente com materiais nobres: rendas importadas, tules de alta gramatura, cetins e mikados premium."},
                {icon:"🌹", t:"Brasil & Europa", d:"Nossos vestidos vestem noivas no Brasil e na Europa há mais de 10 anos, com o mesmo padrão de excelência."},
              ].map((item,i) => (
                <div key={i} style={{padding:"28px 32px",background:"rgba(255,255,255,0.03)",border:"1px solid rgba(185,150,90,0.15)",borderLeft:"3px solid var(--gold)",display:"flex",gap:20,alignItems:"flex-start"}}>
                  <div style={{fontSize:28,flexShrink:0}}>{item.icon}</div>
                  <div>
                    <div style={{fontFamily:"var(--font-display)",fontSize:20,marginBottom:6,letterSpacing:1,color:"var(--white)"}}>{item.t}</div>
                    <div style={{fontSize:13,color:"rgba(255,255,255,0.45)",lineHeight:1.8}}>{item.d}</div>
                  </div>
                </div>
              ))}
            </div>
            <div>
              <h2 className="section-title light">O DIA MAIS<br/><span style={{fontStyle:"italic",color:"var(--gold)"}}>ESPECIAL</span></h2>
              <p style={{fontSize:14,color:"rgba(255,255,255,0.55)",lineHeight:2.2,marginBottom:24,letterSpacing:0.3}}>
                Há mais de 10 anos, a Daniel Abraham atua no segmento nupcial com um compromisso inabalável: nenhuma noiva nossa usa um vestido com cola. É uma questão de respeito ao momento mais especial da vida de uma mulher.
              </p>
              <p style={{fontSize:14,color:"rgba(255,255,255,0.55)",lineHeight:2.2,letterSpacing:0.3}}>
                Cada peça é trabalhada com o mesmo rigor da alta costura europeia. O resultado é um vestido que dura, que mantém sua forma e que conta uma história de qualidade real.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function ProductionPage() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({nome:"",empresa:"",qty:"",estampa:"",prazo:"",obs:""});
  const set = k => e => setForm(f => ({...f,[k]:e.target.value}));

  const submit = async () => {
    if (!form.nome || !form.empresa) { setErr("Preencha nome e empresa."); return; }
    setLoading(true); setErr("");
    try {
      const { error } = await supabase.from("orcamentos").insert({
        name: form.nome, company: form.empresa, quantity: form.qty,
        stamp_type: form.estampa, deadline: form.prazo, notes: form.obs
      });
      if (error) throw error;
      setSent(true);
    } catch(e) { setErr("Erro ao enviar. Tente pelo WhatsApp."); }
    setLoading(false);
  };
  return (
    <div style={{paddingTop:64,minHeight:"100vh"}}>
      <section className="section section-dark">
        <div className="production-grid">
          <div>
            <div className="section-tag">Produção Personalizada</div>
            <div className="divider" />
            <h1 className="section-title light">SUA MARCA<br/>NO SILK</h1>
            <p className="section-desc light" style={{marginBottom:40}}>
              Personalizamos seus ternos e trajes com etiquetas private label diretamente na nossa alfaiataria. Qualidade profissional com a identidade da sua marca.
            </p>
            <div className="prod-features">
              {[
                {icon:"🧵",t:"Costura Premium",d:"Acabamento artesanal com linhas importadas e pontos duplos de alta resistência."},
                {icon:"🏷️",t:"Private Label",d:"Sua marca estampada nas etiquetas internas, externas e embalagens dos ternos."},
                {icon:"🎨",t:"Tecidos Exclusivos",d:"Linho italiano, lã merino e misturas premium disponíveis em diversas cores."},
                {icon:"📦",t:"Pedido Mínimo",d:"Mínimo de 50 unidades por modelo. Ideal para lojistas que buscam exclusividade com volume."},
              ].map((f,i) => (
                <div className="prod-feature" key={i}>
                  <div className="prod-feature-icon">{f.icon}</div>
                  <div>
                    <div className="prod-feature-title">{f.t}</div>
                    <div className="prod-feature-desc">{f.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="form-container">
              <div className="form-title">Solicitar Orçamento</div>
              {sent ? (
                <div className="alert-success">
                  ✅ Orçamento solicitado! Entraremos em contato em até 2 dias úteis.
                </div>
              ) : (
                <>
                  <div className="form-grid">
                    <div className="form-group"><label className="form-label">Seu nome *</label><input className="form-input" value={form.nome} onChange={set("nome")} /></div>
                    <div className="form-group"><label className="form-label">Empresa *</label><input className="form-input" value={form.empresa} onChange={set("empresa")} /></div>
                    <div className="form-group"><label className="form-label">Quantidade *</label><input className="form-input" value={form.qty} onChange={set("qty")} placeholder="Ex: 500 peças" /></div>
                    <div className="form-group"><label className="form-label">Tipo de estampa *</label>
                      <select className="form-select" value={form.estampa} onChange={set("estampa")}>
                        <option value="">Selecione...</option>
                        <option>Private Label Completo</option><option>Etiqueta Interna</option><option>Sem Personalização</option>
                      </select>
                    </div>
                    <div className="form-group form-full"><label className="form-label">Prazo desejado</label><input className="form-input" value={form.prazo} onChange={set("prazo")} placeholder="Ex: 30 dias" /></div>
                    <div className="form-group form-full"><label className="form-label">Observações</label><textarea className="form-textarea" value={form.obs} onChange={set("obs")} placeholder="Detalhes do projeto, referências, etc." /></div>
                  </div>
                  {err && <div className="alert-error" style={{marginBottom:12}}>{err}</div>}
                  <button className="btn-primary" style={{width:"100%",opacity:loading?0.7:1}} onClick={submit} disabled={loading}>
                    {loading ? "Enviando..." : "Solicitar orçamento gratuito"}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function ContactPage() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cErr, setCErr] = useState("");
  const [cForm, setCForm] = useState({name:"",email:"",subject:"",message:""});
  const setC = k => e => setCForm(f=>({...f,[k]:e.target.value}));

  const submitContact = async () => {
    if (!cForm.name || !cForm.message) { setCErr("Preencha nome e mensagem."); return; }
    setLoading(true); setCErr("");
    try {
      const { error } = await supabase.from("messages").insert({
        name: cForm.name, email: cForm.email,
        subject: cForm.subject, message: cForm.message
      });
      if (error) throw error;
      setSent(true);
    } catch(e) { setCErr("Erro ao enviar. Tente pelo WhatsApp."); }
    setLoading(false);
  };

  return (
    <div style={{paddingTop:64,minHeight:"100vh",background:"var(--cream)"}}>
      <div style={{background:"var(--black)",padding:"60px 40px 40px"}}>
        <div className="max-w">
          <div className="section-tag">Contato</div>
          <h1 style={{fontFamily:"var(--font-display)",fontSize:"clamp(56px,8vw,100px)",color:"var(--white)",lineHeight:1}}>FALE<br/><span style={{color:"var(--gold)"}}>CONOSCO</span></h1>
        </div>
      </div>
      <div style={{padding:"60px 40px"}}>
        <div className="contact-grid max-w">
          <div>
            <h2 style={{fontFamily:"var(--font-display)",fontSize:36,marginBottom:32}}>INFORMAÇÕES</h2>
            {[
              {icon:"📱",label:"WhatsApp",value:"(11) 94260-0546"},
              {icon:"📞",label:"Telefone",value:"(11) 94260-0546"},
              {icon:"📧",label:"E-mail",value:"danielabrahamcamisetas@gmail.com"},
              {icon:"📍",label:"Endereço",value:"R. Xavantes, 824 — Brás, São Paulo, SP, 03027-000"},
              {icon:"🕐",label:"Horário",value:"Seg–Sáb: 9h às 14h"},
            ].map((item,i) => (
              <div className="contact-item" key={i}>
                <div className="contact-icon">{item.icon}</div>
                <div>
                  <div className="contact-label">{item.label}</div>
                  <div className="contact-value">{item.value}</div>
                </div>
              </div>
            ))}
            <a href="https://wa.me/5511942600546" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
              <button className="btn-whatsapp" style={{marginTop:24,width:"auto",padding:"14px 32px"}}>
                <WhatsAppIcon /> Chamar no WhatsApp
              </button>
            </a>
          </div>
          <div>
            <h2 style={{fontFamily:"var(--font-display)",fontSize:36,marginBottom:32}}>ENVIE UMA MENSAGEM</h2>
            {sent ? (
              <div className="alert-success">✅ Mensagem enviada! Responderemos em até 24h.</div>
            ) : (
              <div>
                <div className="form-group"><label className="form-label">Nome</label><input className="form-input" value={cForm.name} onChange={setC("name")} /></div>
                <div className="form-group"><label className="form-label">E-mail</label><input className="form-input" value={cForm.email} onChange={setC("email")} /></div>
                <div className="form-group"><label className="form-label">Assunto</label><input className="form-input" value={cForm.subject} onChange={setC("subject")} /></div>
                <div className="form-group"><label className="form-label">Mensagem</label><textarea className="form-textarea" rows={5} value={cForm.message} onChange={setC("message")} /></div>
                {cErr && <div className="alert-error" style={{marginBottom:12}}>{cErr}</div>}
                <button className="btn-primary" style={{opacity:loading?0.7:1}} onClick={submitContact} disabled={loading}>
                  {loading ? "Enviando..." : "Enviar mensagem"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── B2B PORTAL ───────────────────────────────────────────────────────────────

function B2BCatalogTab() {
  const [products, setProducts] = useState(PRODUCTS);
  useEffect(() => {
    supabase.from("products").select("*").eq("active", true)
      .then(({ data }) => { if (data && data.length > 0) setProducts(data.map(p=>({...p,group:p.group_name,tipo:p.tipo||p.group_name,modelo:p.modelo||'',mainPhotos:p.main_photos||(p.main_photo?[p.main_photo]:[]),desc:p.description,stock:{}}))); });
  }, []);
  return (
    <div>
      <div className="portal-header">
        <div className="portal-title">COLEÇÃO B2B</div>
        <div className="portal-sub">Preços de atacado exclusivos para lojistas</div>
      </div>
      {products.map(p => (
        <div className="b2b-product-row" key={p.id}>
          <div className="b2b-thumb">👕</div>
          <div>
            <div className="b2b-name">{p.name}</div>
            <div className="b2b-fabric">{p.fabric}</div>
            <div style={{display:"flex",gap:6,marginTop:8}}>
              {p.colors.map(c => <div key={c} className="color-dot" style={{background:COLOR_HEX[c]||"#888",width:16,height:16}} title={c} />)}
            </div>
            <div style={{fontSize:12,color:"var(--gray)",marginTop:4}}>Tamanhos: {p.sizes.join(" · ")}</div>
          </div>
          <div className="b2b-price-box">
            <div className="b2b-price">R$ {Math.min(...(p.sizes||[]).map(s=>parseFloat(p.priceGradeSizes?.[s])||p.priceGrade||0)).toFixed(2).replace(".",",")}</div>
            <div className="b2b-price-type">Grade Fechada (min)</div>
          </div>
          <div className="b2b-price-box">
            <div className="b2b-price" style={{color:"var(--gray)"}}>R$ {Math.min(...(p.sizes||[]).map(s=>parseFloat(p.priceBreakSizes?.[s])||p.priceBreak||0)).toFixed(2).replace(".",",")}</div>
            <div className="b2b-price-type">Grade Quebrada (min)</div>
          </div>
          <div>
            <span className="status-badge status-active">Disponível</span>
          </div>
        </div>
      ))}
    </div>
  );
}

function B2BStockTab() {
  const [products, setProducts] = useState(PRODUCTS);
  useEffect(() => {
    const load = async () => {
      const { data: prods } = await supabase.from("products").select("*").eq("active", true);
      if (!prods || prods.length === 0) return;
      const { data: stockRows } = await supabase.from("stock").select("*");
      const mapped = prods.map(p => {
        const stock = {};
        (p.colors||[]).forEach(c => {
          stock[c] = {};
          (p.sizes||[]).forEach(s => {
            const row = (stockRows||[]).find(r => r.product_id === p.id && r.color === c && r.size === s);
            stock[c][s] = row ? row.quantity : 0;
          });
        });
        return {...p, group:p.group_name, tipo:p.tipo||p.group_name, modelo:p.modelo||'', desc:p.description, stock};
      });
      setProducts(mapped);
    };
    load();
  }, []);
  return (
    <div>
      <div className="portal-header">
        <div className="portal-title">ESTOQUE — TERNOS</div>
        <div className="portal-sub">Atualizado em tempo real pela administração</div>
      </div>
      {products.map(p => (
        <div key={p.id} style={{marginBottom:32}}>
          <div style={{fontFamily:"var(--font-display)",fontSize:24,marginBottom:8}}>{p.name}</div>
          <table className="stock-table">
            <thead>
              <tr>
                <th>Cor</th>
                {p.sizes.map(s => <th key={s}>{s}</th>)}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {p.colors.map(c => {
                const sObj = p.stock[c] || {};
                const total = Object.values(sObj).reduce((a,b)=>a+b,0);
                return (
                  <tr key={c}>
                    <td style={{display:"flex",alignItems:"center",gap:8}}>
                      <div style={{width:14,height:14,borderRadius:"50%",background:COLOR_HEX[c]||"#888",border:"1px solid #ddd"}} />
                      {c}
                    </td>
                    {p.sizes.map(s => {
                      const qty = sObj[s] || 0;
                      return <td key={s}><span className={`stock-chip ${qty<50?"low":qty>100?"ok":""}`}>{qty}</span></td>;
                    })}
                    <td><strong>{total}</strong></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

function B2BOrderTab({ user, kits }) {
  const [selProduct, setSelProduct] = useState(null);
  const [selColor, setSelColor] = useState(null);
  const [gradeType, setGradeType] = useState(null);   // "fechada" | "quebrada"
  const [kitOrders, setKitOrders] = useState({});      // { kitId: qtdKits }
  const [qtysBreak, setQtysBreak] = useState({});      // grade quebrada: { size: qty }
  const [sent, setSent] = useState(false);
  const [toast, setToast] = useState("");
  const product = PRODUCTS.find(p => p.id === selProduct);

  // Which kits apply to this product?
  const availableKits = kits.filter(k => {
    if (!k.active) return false;
    // Kit is available if product has ALL sizes in that kit
    return Object.keys(k.sizes).every(s => product?.sizes?.includes(s));
  });

  // Total pieces per kit
  const kitTotal = (kit) => Object.values(kit.sizes).reduce((a,b)=>a+b,0);

  // Compute totals for grade fechada
  const fechadaTotals = {}; // { size: totalPcs }
  if (gradeType === "fechada") {
    availableKits.forEach(kit => {
      const qty = parseInt(kitOrders[kit.id]) || 0;
      Object.entries(kit.sizes).forEach(([s, perKit]) => {
        fechadaTotals[s] = (fechadaTotals[s] || 0) + perKit * qty;
      });
    });
  }

  const totalPcs = gradeType === "fechada"
    ? Object.values(fechadaTotals).reduce((a,b)=>a+b,0)
    : Object.values(qtysBreak).reduce((a,b)=>a+(parseInt(b)||0),0);

  // Per-size price calculation
  const getSizePrice = (size, type) => {
    if (!product) return 0;
    if (type === "fechada") return parseFloat(product.priceGradeSizes?.[size]) || product.priceGrade || 0;
    return parseFloat(product.priceBreakSizes?.[size]) || product.priceBreak || 0;
  };
  const minPrice = product
    ? (gradeType === "fechada"
        ? Math.min(...(product.sizes||[]).map(s=>getSizePrice(s,"fechada")))
        : Math.min(...(product.sizes||[]).map(s=>getSizePrice(s,"quebrada"))))
    : 0;
  const totalValue = gradeType === "fechada"
    ? Object.entries(fechadaTotals).reduce((acc,[s,n])=>acc+getSizePrice(s,"fechada")*n, 0).toFixed(2)
    : Object.entries(qtysBreak).reduce((acc,[s,q])=>acc+getSizePrice(s,"quebrada")*(parseInt(q)||0), 0).toFixed(2);

  const reset = () => {
    setSelProduct(null); setSelColor(null); setGradeType(null);
    setKitOrders({}); setQtysBreak({}); setSent(false); setToast("");
  };

  const sendWhatsApp = async () => {
    if (!product || !selColor || !gradeType || totalPcs === 0) {
      setToast("Complete o pedido antes de enviar."); return;
    }

    let detalhes = "";
    if (gradeType === "fechada") {
      availableKits.forEach(kit => {
        const qty = parseInt(kitOrders[kit.id]) || 0;
        if (qty > 0) {
          const pcs = Object.entries(kit.sizes).map(([s,n])=>`${s}×${n}`).join(", ");
          detalhes += `\n📦 ${kit.name}: ${qty} kit(s) → ${pcs}`;
        }
      });
      detalhes += "\n\n*Peças por tamanho:*";
      Object.entries(fechadaTotals).forEach(([s,n]) => { if(n>0) detalhes += `\n${s} — ${n} un.`; });
    } else {
      detalhes = "\n*Quantidades:*";
      product.sizes.forEach(s => {
        const q = parseInt(qtysBreak[s])||0;
        if(q>0) detalhes += `\n${s} — ${q} un.`;
      });
    }

    const msg = encodeURIComponent(
      `🛍️ *PEDIDO ATACADO — ${user.store}*\n\n` +
      `Produto: ${product.name}\nCor: ${selColor}\nTipo: Grade ${gradeType}` +
      detalhes +
      `\n\nTotal de peças: ${totalPcs}\nPreço a partir de: R$ ${minPrice.toFixed(2)}\n*Total estimado: R$ ${totalValue}*\n\nLojista: ${user.name} — ${user.store_name || user.store}`
    );
    window.open(`https://wa.me/5511942600546?text=${msg}`, "_blank");
    // Save order to Supabase
    try {
      await supabase.from("orders").insert({
        lojista_id: user.id || null,
        lojista_name: user.name,
        store_name: user.store_name || user.store,
        product_id: product.id || null,
        product_name: product.name,
        color: selColor,
        grade_type: gradeType,
        quantities: gradeType === "quebrada" ? qtysBreak : kitOrders,
        total_pieces: totalPcs,
        total_value: parseFloat(totalValue)
      });
    } catch(e) { /* order saved to WhatsApp regardless */ }
    setSent(true);
  };

  if (sent) return (
    <div style={{textAlign:"center",padding:"80px 40px"}}>
      <div style={{fontSize:80,marginBottom:24}}>✅</div>
      <div style={{fontFamily:"var(--font-display)",fontSize:48,marginBottom:16}}>PEDIDO ENVIADO!</div>
      <p style={{color:"var(--gray)",marginBottom:32}}>Seu pedido foi enviado via WhatsApp. Aguarde a confirmação da nossa equipe.</p>
      <button className="btn-primary" onClick={reset}>Fazer novo pedido</button>
    </div>
  );

  return (
    <div>
      <div className="portal-header">
        <div className="portal-title">FAZER PEDIDO — TERNOS</div>
        <div className="portal-sub">Monte seu pedido e envie direto pelo WhatsApp</div>
      </div>
      <div className="order-builder">
        <div>

          {/* Step 1 — Produto */}
          <div className="order-step">
            <div className="order-step-num">01</div>
            <div className="order-step-title">Selecione o Produto</div>
            <div className="product-select-grid">
              {PRODUCTS.map(p => (
                <div key={p.id} className={`product-select-item ${selProduct===p.id?"selected":""}`}
                  onClick={() => { setSelProduct(p.id); setSelColor(null); setGradeType(null); setKitOrders({}); setQtysBreak({}); }}>
                  <div className="product-select-icon">👕</div>
                  <div className="product-select-name" style={{fontSize:11}}>{p.name}</div>
                  <div style={{fontSize:10,color:"var(--gray)",marginTop:4,fontFamily:"var(--font-mono)"}}>{p.group}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Step 2 — Cor */}
          {product && (
            <div className="order-step">
              <div className="order-step-num">02</div>
              <div className="order-step-title">Selecione a Cor</div>
              <div className="color-select">
                {product.colors.map(c => (
                  <button key={c} className={`color-btn ${selColor===c?"selected":""}`} onClick={() => setSelColor(c)}>
                    <div style={{width:16,height:16,borderRadius:"50%",background:COLOR_HEX[c]||"#888",border:"1px solid #ccc"}} />
                    {c}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Step 3 — Tipo de Grade */}
          {selColor && (
            <div className="order-step">
              <div className="order-step-num">03</div>
              <div className="order-step-title">Tipo de Grade</div>
              <div className="grade-options">
                <div className={`grade-option ${gradeType==="fechada"?"selected":""}`}
                  onClick={() => { setGradeType("fechada"); setKitOrders({}); setQtysBreak({}); }}>
                  <div className="grade-option-title">Grade Fechada</div>
                  <div className="grade-option-desc">Kits prontos com distribuição de tamanhos definida.</div>
                  <div className="grade-option-price">
                    a partir de R$ {Math.min(...(product.sizes||[]).map(s=>parseFloat(product.priceGradeSizes?.[s])||product.priceGrade||0)).toFixed(2).replace(".",",")} /peça
                  </div>
                </div>
                <div className={`grade-option ${gradeType==="quebrada"?"selected":""}`}
                  onClick={() => { setGradeType("quebrada"); setKitOrders({}); setQtysBreak({}); }}>
                  <div className="grade-option-title">Grade Quebrada</div>
                  <div className="grade-option-desc">Você escolhe livremente a quantidade por tamanho.</div>
                  <div className="grade-option-price">
                    a partir de R$ {Math.min(...(product.sizes||[]).map(s=>parseFloat(product.priceBreakSizes?.[s])||product.priceBreak||0)).toFixed(2).replace(".",",")} /peça
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 4 — Quantidades */}
          {gradeType === "fechada" && (
            <div className="order-step">
              <div className="order-step-num">04</div>
              <div className="order-step-title">Quantos Kits?</div>

              {availableKits.length === 0 && (
                <div style={{padding:16,background:"#fef9c3",border:"1px solid #fde047",fontSize:13,color:"#854d0e"}}>
                  ⚠️ Nenhum kit disponível para este produto. Use grade quebrada.
                </div>
              )}

              {availableKits.map(kit => (
                <div key={kit.id} style={{marginBottom:20,padding:20,border:"2px solid var(--border)",background:"var(--cream)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12,flexWrap:"wrap",gap:8}}>
                    <div>
                      <div style={{fontFamily:"var(--font-display)",fontSize:22}}>{kit.name}</div>
                      <div style={{fontSize:12,color:"var(--gray)",marginTop:2}}>{kit.desc}</div>
                    </div>
                    <div style={{background:"var(--black)",color:"var(--white)",padding:"4px 12px",fontFamily:"var(--font-mono)",fontSize:11}}>
                      {kitTotal(kit)} peças/kit
                    </div>
                  </div>

                  {/* Kit composition */}
                  <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
                    {Object.entries(kit.sizes).map(([s,n]) => (
                      <div key={s} style={{padding:"6px 12px",background:"var(--white)",border:"1px solid var(--border)",textAlign:"center"}}>
                        <div style={{fontFamily:"var(--font-mono)",fontSize:10,color:"var(--gray)",textTransform:"uppercase"}}>{s}</div>
                        <div style={{fontFamily:"var(--font-display)",fontSize:24,color:"var(--gold)"}}>{n}</div>
                      </div>
                    ))}
                  </div>

                  {/* Kit qty input */}
                  <div style={{display:"flex",alignItems:"center",gap:16}}>
                    <div>
                      <div style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--gray)",textTransform:"uppercase",letterSpacing:1.5,marginBottom:6}}>
                        Quantidade de kits
                      </div>
                      <input type="number" min={0}
                        value={kitOrders[kit.id] || ""}
                        onChange={e => setKitOrders(o => ({...o, [kit.id]: e.target.value}))}
                        style={{width:100,padding:"8px 12px",border:"1.5px solid var(--border)",fontFamily:"var(--font-display)",fontSize:32,textAlign:"center",background:"var(--white)",outline:"none"}}
                      />
                    </div>
                    {(parseInt(kitOrders[kit.id])||0) > 0 && (
                      <div style={{padding:12,background:"var(--white)",border:"1px solid var(--border)"}}>
                        <div style={{fontSize:11,color:"var(--gray)",fontFamily:"var(--font-mono)",marginBottom:4}}>SUBTOTAL DESTE KIT</div>
                        <div style={{fontFamily:"var(--font-display)",fontSize:20,color:"var(--gold)"}}>
                          {kitTotal(kit) * (parseInt(kitOrders[kit.id])||0)} peças
                        </div>
                        <div style={{fontSize:12,color:"var(--gray)"}}>
                          {Object.entries(kit.sizes).map(([s,n])=>`${n*((parseInt(kitOrders[kit.id])||0))} ${s}`).join(" · ")}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {/* Preview final por tamanho */}
              {totalPcs > 0 && (
                <div style={{marginTop:16,padding:16,background:"#f0fdf4",border:"1px solid #86efac"}}>
                  <div style={{fontFamily:"var(--font-mono)",fontSize:11,color:"#166534",letterSpacing:2,marginBottom:10}}>✓ PEÇAS POR TAMANHO</div>
                  <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                    {Object.entries(fechadaTotals).filter(([,n])=>n>0).map(([s,n]) => (
                      <div key={s} style={{padding:"8px 16px",background:"var(--white)",border:"1px solid #86efac",textAlign:"center"}}>
                        <div style={{fontFamily:"var(--font-mono)",fontSize:10,color:"#166534"}}>{s}</div>
                        <div style={{fontFamily:"var(--font-display)",fontSize:28}}>{n}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {gradeType === "quebrada" && (
            <div className="order-step">
              <div className="order-step-num">04</div>
              <div className="order-step-title">Quantidades por Tamanho</div>
              <div className="qty-grid">
                {product.sizes.map(s => (
                  <div className="qty-item" key={s}>
                    <div className="qty-label">Tamanho {s}</div>
                    <input type="number" className="qty-input" min={0}
                      value={qtysBreak[s] || ""}
                      onChange={e => setQtysBreak(q => ({...q, [s]: e.target.value}))}
                    />
                    <div style={{fontSize:11,color:"var(--gray)",marginTop:4,fontFamily:"var(--font-mono)"}}>
                      Estoque: {(product.stock[selColor]||{})[s]||0}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>

        {/* SUMMARY */}
        <div className="order-summary">
          <div className="summary-title">RESUMO</div>
          <div className="summary-row"><span className="summary-label">Produto</span><span className="summary-value" style={{fontSize:13}}>{product?.name || "—"}</span></div>
          <div className="summary-row"><span className="summary-label">Cor</span><span className="summary-value">{selColor || "—"}</span></div>
          <div className="summary-row"><span className="summary-label">Grade</span><span className="summary-value">{gradeType ? `Grade ${gradeType}` : "—"}</span></div>

          {gradeType === "fechada" && availableKits.map(kit => {
            const qty = parseInt(kitOrders[kit.id])||0;
            if (!qty) return null;
            return (
              <div key={kit.id} className="summary-row">
                <span className="summary-label">{kit.name}</span>
                <span className="summary-value">{qty} kit(s)</span>
              </div>
            );
          })}

          {gradeType === "quebrada" && product && product.sizes.map(s => {
            const q = parseInt(qtysBreak[s])||0;
            if (!q) return null;
            return (
              <div key={s} className="summary-row" style={{fontSize:12}}>
                <span className="summary-label">Tam. {s}</span>
                <span>{q} un.</span>
              </div>
            );
          })}

          <div className="summary-row"><span className="summary-label">Total peças</span><span className="summary-value">{totalPcs}</span></div>
          <div className="summary-row"><span className="summary-label">Preço a partir de</span><span className="summary-value">R$ {minPrice > 0 ? minPrice.toFixed(2).replace(".",",") : "—"}</span></div>

          <div style={{marginTop:24,borderTop:"1px solid rgba(255,255,255,0.1)",paddingTop:20}}>
            <div className="summary-total-label">Total estimado</div>
            <div className="summary-total">R$ {parseFloat(totalValue).toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
          </div>
          <button className="btn-whatsapp" onClick={sendWhatsApp}>
            <WhatsAppIcon /> Enviar pedido via WhatsApp
          </button>
          <div style={{marginTop:12,fontSize:11,color:"rgba(255,255,255,0.3)",textAlign:"center",fontFamily:"var(--font-mono)"}}>
            Nossa equipe confirmará disponibilidade e prazo.
          </div>
          {toast && <Toast msg={toast} onClose={() => setToast("")} />}
        </div>
      </div>
    </div>
  );
}



const ALL_SIZES = ["44","46","48","50","52","54","56","58","60","62","64","PP","P","M","G","GG"];
const PRESET_COLORS = ["Preto","Marinho","Cinza Chumbo","Cinza Claro","Bege","Caramelo","Bordô","Azul Royal","Verde Oliva","Grafite","Caqui","Marrom","Branco Noiva","Marfim","Champagne","Rosê","Nude","Prata"];

function ProductFormModal({ product, onSave, onClose, allProducts }) {
  const isEdit = !!product;
  const emptyForm = {
    name:"", fabric:"", tipo:"Terno", modelo:"Slim Fit", desc:"", badge:"",
    sizes:["44","46","48","50","52","54","56"],
    colors:[], customColor:"", active:true, photos:{}, mainPhotos:[],
    customTipo:"", customModelo:"",
  };
  const [form, setForm] = useState(isEdit ? {
    ...product,
    tipo: product.tipo || "Terno",
    modelo: product.modelo || "",
    mainPhotos: product.mainPhotos || (product.main_photo ? [product.main_photo] : []),
    customColor:"", customTipo:"", customModelo:"",
    photos: product.photos || {},
  } : emptyForm);
  const [tipoOptions, setTipoOptions] = useState(DEFAULT_TIPOS);
  const [modeloOptions, setModeloOptions] = useState(DEFAULT_MODELOS);
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState({});
  const set = k => v => setForm(f=>({...f,[k]:v}));
  const setE = k => e => set(k)(e.target.value);
  const toggleSize = s => set("sizes")(form.sizes.includes(s)?form.sizes.filter(x=>x!==s):[...form.sizes,s].sort((a,b)=>ALL_SIZES.indexOf(a)-ALL_SIZES.indexOf(b)));
  const toggleColor = c => set("colors")(form.colors.includes(c)?form.colors.filter(x=>x!==c):[...form.colors,c]);
  const addCustomColor = () => { const c=form.customColor.trim(); if(!c)return; if(!form.colors.includes(c))set("colors")([...form.colors,c]); set("customColor")(""); };

  const addCustomTipo = () => {
    const v = form.customTipo.trim();
    if (!v) return;
    if (!tipoOptions.includes(v)) setTipoOptions(t => [...t, v]);
    set("tipo")(v); set("customTipo")("");
  };
  const addCustomModelo = () => {
    const v = form.customModelo.trim();
    if (!v) return;
    if (!modeloOptions.includes(v)) setModeloOptions(m => [...m, v]);
    set("modelo")(v); set("customModelo")("");
  };

  const [uploadingMainIdx, setUploadingMainIdx] = useState(null);

  const uploadMainPhoto = async (file, idx) => {
    if (!file) return;
    setUploadingMainIdx(idx);
    try {
      const ext = file.name.split(".").pop();
      const path = `produtos/${Date.now()}-main${idx}.${ext}`;
      const { error: upErr } = await supabase.storage.from("product-images").upload(path, file, {upsert:true});
      if (upErr) throw upErr;
      const { data: urlData } = supabase.storage.from("product-images").getPublicUrl(path);
      const updated = [...(form.mainPhotos||[])];
      if (idx < updated.length) updated[idx] = urlData.publicUrl;
      else updated.push(urlData.publicUrl);
      set("mainPhotos")(updated);
    } catch(e) { alert("Erro ao fazer upload: " + e.message); }
    setUploadingMainIdx(null);
  };

  const removeMainPhoto = (idx) => {
    const updated = [...(form.mainPhotos||[])];
    updated.splice(idx, 1);
    set("mainPhotos")(updated);
  };

  const uploadPhoto = async (color, file) => {
    if (!file) return;
    setUploading(u=>({...u,[color]:true}));
    try {
      const ext = file.name.split(".").pop();
      const path = `produtos/${Date.now()}-${color.replace(/\s/g,"_")}.${ext}`;
      const { error: upErr } = await supabase.storage.from("product-images").upload(path, file, {upsert:true});
      if (upErr) throw upErr;
      const { data: urlData } = supabase.storage.from("product-images").getPublicUrl(path);
      set("photos")({...form.photos, [color]: urlData.publicUrl});
    } catch(e) { alert("Erro ao fazer upload: " + e.message); }
    setUploading(u=>({...u,[color]:false}));
  };

  const save = () => {
    if (!form.name.trim()) { setError("Nome obrigatório."); return; }
    if (!form.tipo.trim()) { setError("Tipo obrigatório."); return; }
    if (form.sizes.length === 0) { setError("Selecione ao menos um tamanho."); return; }
    onSave({
      ...form, id: product?.id || Date.now(),
      badge: form.badge.trim() || null,
      group_name: form.tipo,
      mainPhotos: form.mainPhotos || [],
      photos: form.photos,
    });
    onClose();
  };

  const inp = {padding:"10px 14px",border:"1.5px solid var(--border)",background:"var(--cream)",fontFamily:"var(--font-body)",fontSize:14,color:"var(--black)",outline:"none",width:"100%"};
  const lbl = {fontSize:10,fontFamily:"var(--font-body)",textTransform:"uppercase",letterSpacing:"2px",color:"var(--gray)",marginBottom:6,display:"block"};

  const TagSelector = ({ label, value, options, onSelect, customVal, onCustomChange, onCustomAdd, onRemoveOption }) => (
    <div style={{marginBottom:20}}>
      <label style={lbl}>{label}</label>
      <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:12,alignItems:"start"}}>
        {/* Left: tag pills */}
        <div style={{display:"flex",gap:6,flexWrap:"wrap",padding:12,border:"1px solid var(--border)",background:"white",minHeight:52}}>
          {options.map(o => (
            <div key={o} onClick={() => onSelect(o)}
              style={{display:"inline-flex",alignItems:"center",gap:4,padding:"5px 12px",cursor:"pointer",fontSize:12,fontFamily:"var(--font-body)",letterSpacing:0.5,border:"1px solid",transition:"all 0.2s",
                borderColor: value===o ? "var(--gold)" : "var(--border)",
                background: value===o ? "var(--gold)" : "transparent",
                color: value===o ? "var(--black)" : "var(--gray)"}}>
              {o}
              <span onClick={e=>{e.stopPropagation();onRemoveOption(o);}}
                style={{marginLeft:2,opacity:0.4,fontSize:10,lineHeight:1,cursor:"pointer"}}>✕</span>
            </div>
          ))}
        </div>
        {/* Right: add custom */}
        <div style={{display:"flex",flexDirection:"column",gap:6,minWidth:180}}>
          <input style={{...inp,padding:"8px 12px",fontSize:13}} value={customVal} onChange={onCustomChange}
            placeholder="+ Personalizar..." onKeyDown={e=>e.key==="Enter"&&onCustomAdd()} />
          <button onClick={onCustomAdd}
            style={{padding:"8px 14px",background:"var(--black)",color:"var(--white)",border:"none",cursor:"pointer",fontFamily:"var(--font-body)",fontSize:11,letterSpacing:1.5,textTransform:"uppercase"}}>
            Adicionar
          </button>
        </div>
      </div>
      {value && <div style={{marginTop:8,fontSize:12,color:"var(--gold)",fontFamily:"var(--font-body)",letterSpacing:0.5}}>Selecionado: <strong>{value}</strong></div>}
    </div>
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:760,padding:48}} onClick={e=>e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title" style={{fontSize:32}}>{isEdit ? "Editar Produto" : "Novo Produto"}</div>
        <div className="modal-sub">{isEdit ? `Editando: ${product.name}` : "Preencha os dados do produto"}</div>

        {/* Nome + Badge */}
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:16,marginBottom:16}}>
          <div><label style={lbl}>Nome *</label><input style={inp} value={form.name} onChange={setE("name")} placeholder="Ex: Terno Slim Azul Marinho" /></div>
          <div><label style={lbl}>Badge</label><input style={inp} value={form.badge} onChange={setE("badge")} placeholder="NOVO · DESTAQUE" /></div>
        </div>

        {/* Tecido + Descrição */}
        <div style={{marginBottom:16}}><label style={lbl}>Tecido / Material</label><input style={inp} value={form.fabric} onChange={setE("fabric")} placeholder="Ex: Lã Merino 100%, Linho Italiano..." /></div>
        <div style={{marginBottom:20}}><label style={lbl}>Descrição</label><textarea style={{...inp,resize:"vertical",minHeight:72}} value={form.desc} onChange={setE("desc")} /></div>

        <div style={{height:1,background:"var(--border)",marginBottom:24}} />

        {/* TIPO */}
        <TagSelector
          label="Tipo de Produto *"
          value={form.tipo}
          options={tipoOptions}
          onSelect={v => set("tipo")(v)}
          customVal={form.customTipo}
          onCustomChange={setE("customTipo")}
          onCustomAdd={addCustomTipo}
          onRemoveOption={o => {
            const inUse = (allProducts||[]).some(p => (p.tipo||p.group_name)===o && p.id !== product?.id);
            if (inUse) { alert(`Não é possível remover "${o}" — existem produtos cadastrados com este tipo.`); return; }
            if(form.tipo===o) set("tipo")(""); setTipoOptions(t=>t.filter(x=>x!==o));
          }}
        />

        {/* MODELO */}
        <TagSelector
          label="Modelo"
          value={form.modelo}
          options={modeloOptions}
          onSelect={v => set("modelo")(v)}
          customVal={form.customModelo}
          onCustomChange={setE("customModelo")}
          onCustomAdd={addCustomModelo}
          onRemoveOption={o => { if(form.modelo===o) set("modelo")(""); setModeloOptions(m=>m.filter(x=>x!==o)); }}
        />

        <div style={{height:1,background:"var(--border)",marginBottom:24}} />

        {/* FOTOS PRINCIPAIS */}
        <div style={{marginBottom:24}}>
          <label style={lbl}>📸 Fotos Principais — até 5 <span style={{opacity:0.5,fontWeight:300}}>(a primeira aparece no catálogo)</span></label>
          <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:10}}>
            {[0,1,2,3,4].map(idx => {
              const url = (form.mainPhotos||[])[idx];
              const isUploading = uploadingMainIdx === idx;
              return (
                <div key={idx} style={{display:"flex",flexDirection:"column",gap:6}}>
                  <div style={{aspectRatio:"3/4",background:"var(--parchment)",border: idx===0?"2px solid var(--gold)":"1px dashed var(--border)",overflow:"hidden",display:"flex",alignItems:"center",justifyContent:"center",position:"relative"}}>
                    {url
                      ? <img src={url} alt={`foto ${idx+1}`} style={{width:"100%",height:"100%",objectFit:"cover"}} />
                      : <span style={{fontSize:24,opacity:0.15}}>🧥</span>}
                    {isUploading && <div style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:11}}>...</div>}
                    {idx===0 && <div style={{position:"absolute",bottom:0,left:0,right:0,background:"var(--gold)",color:"var(--black)",fontSize:9,textAlign:"center",padding:"2px 0",fontFamily:"var(--font-body)",letterSpacing:1,textTransform:"uppercase"}}>Principal</div>}
                  </div>
                  <label style={{display:"block",padding:"5px 8px",background:"var(--black)",color:"var(--white)",fontSize:9,fontFamily:"var(--font-body)",cursor:"pointer",letterSpacing:1,textTransform:"uppercase",textAlign:"center"}}>
                    {url ? "Trocar" : "+ Foto"}
                    <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>uploadMainPhoto(e.target.files[0], idx)} />
                  </label>
                  {url && (
                    <button onClick={()=>removeMainPhoto(idx)} style={{padding:"4px",border:"1px solid #fca5a5",color:"#dc2626",background:"none",cursor:"pointer",fontSize:9,fontFamily:"var(--font-body)"}}>
                      Remover
                    </button>
                  )}
                </div>
              );
            })}
          </div>
          <div style={{fontSize:11,color:"var(--gray)",marginTop:8,letterSpacing:0.3}}>
            A primeira foto (borda dourada) é usada no card do catálogo. As demais aparecem na galeria do produto.
          </div>
        </div>

        <div style={{height:1,background:"var(--border)",marginBottom:24}} />

        {/* TAMANHOS */}
        <div style={{marginBottom:20}}>
          <label style={lbl}>Tamanhos *</label>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {ALL_SIZES.map(s=>(
              <button key={s} onClick={()=>toggleSize(s)} style={{padding:"8px 16px",border:"2px solid",cursor:"pointer",fontFamily:"var(--font-body)",fontSize:13,fontWeight:600,letterSpacing:0.5,transition:"all 0.2s",
                borderColor:form.sizes.includes(s)?"var(--gold)":"var(--border)",
                background:form.sizes.includes(s)?"var(--gold)":"transparent",
                color:"var(--black)"}}>
                {s}
              </button>
            ))}
          </div>
        </div>

        <div style={{height:1,background:"var(--border)",marginBottom:24}} />

        {/* CORES */}
        <div style={{marginBottom:20}}>
          <label style={lbl}>Cores <span style={{fontWeight:300,opacity:0.6}}>(opcional — para produtos sem variação de cor deixe em branco)</span></label>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
            {PRESET_COLORS.map(c=>(
              <button key={c} onClick={()=>toggleColor(c)} title={c}
                style={{display:"flex",alignItems:"center",gap:6,padding:"6px 12px",border:"2px solid",cursor:"pointer",fontSize:12,transition:"all 0.2s",
                  borderColor:form.colors.includes(c)?"var(--gold)":"var(--border)",
                  background:form.colors.includes(c)?"#f8f2e4":"transparent"}}>
                <div style={{width:14,height:14,borderRadius:"50%",background:COLOR_HEX[c]||"#888",border:"1px solid #ccc",flexShrink:0}}/>{c}
              </button>
            ))}
          </div>
          <div style={{display:"flex",gap:8}}>
            <input style={{...inp,flex:1}} value={form.customColor} onChange={setE("customColor")} placeholder="Cor personalizada..." onKeyDown={e=>e.key==="Enter"&&addCustomColor()}/>
            <button onClick={addCustomColor} style={{padding:"10px 20px",background:"var(--black)",color:"var(--white)",border:"none",cursor:"pointer",fontFamily:"var(--font-body)",fontSize:11,letterSpacing:1.5,textTransform:"uppercase"}}>+ Cor</button>
          </div>
          {form.colors.length > 0 && (
            <div style={{marginTop:10,display:"flex",gap:6,flexWrap:"wrap"}}>
              {form.colors.map(c=>(
                <span key={c} style={{display:"flex",alignItems:"center",gap:4,padding:"4px 10px",background:"var(--black)",color:"var(--white)",fontSize:12}}>
                  <div style={{width:10,height:10,borderRadius:"50%",background:COLOR_HEX[c]||"#888"}}/>{c}
                  <span onClick={()=>toggleColor(c)} style={{cursor:"pointer",marginLeft:4,opacity:0.6}}>✕</span>
                </span>
              ))}
            </div>
          )}
        </div>

        {/* FOTOS POR COR */}
        {form.colors.length > 0 && (
          <div style={{marginBottom:24,padding:20,background:"#f8f8f8",border:"1px solid var(--border)"}}>
            <label style={lbl}>📸 Fotos por cor <span style={{fontWeight:300,opacity:0.6}}>(opcional — uma foto diferente para cada cor)</span></label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:12}}>
              {form.colors.map(c => (
                <div key={c} style={{textAlign:"center"}}>
                  <div style={{width:"100%",aspectRatio:"3/4",background:"#eee",marginBottom:8,overflow:"hidden",position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}}>
                    {form.photos?.[c]
                      ? <img src={form.photos[c]} alt={c} style={{width:"100%",height:"100%",objectFit:"cover"}} />
                      : <span style={{fontSize:32,opacity:0.3}}>🧥</span>}
                    {uploading[c] && <div style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:11}}>Enviando...</div>}
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:4,justifyContent:"center",marginBottom:6}}>
                    <div style={{width:10,height:10,borderRadius:"50%",background:COLOR_HEX[c]||"#888",flexShrink:0}}/>
                    <span style={{fontSize:11,fontFamily:"var(--font-body)",letterSpacing:0.5}}>{c}</span>
                  </div>
                  <label style={{display:"block",padding:"6px 10px",background:"var(--black)",color:"var(--white)",fontSize:10,fontFamily:"var(--font-body)",cursor:"pointer",letterSpacing:1,textTransform:"uppercase"}}>
                    {form.photos?.[c] ? "Trocar" : "+ Foto"}
                    <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>uploadPhoto(c, e.target.files[0])} />
                  </label>
                  {form.photos?.[c] && (
                    <button onClick={()=>set("photos")({...form.photos,[c]:null})}
                      style={{marginTop:4,width:"100%",padding:"4px",border:"1px solid #fca5a5",color:"#dc2626",background:"none",cursor:"pointer",fontSize:10}}>
                      Remover
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {error && <div className="alert-error" style={{marginBottom:16}}>{error}</div>}
        <div style={{display:"flex",gap:12,justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{padding:"12px 28px",border:"1px solid var(--border)",background:"transparent",cursor:"pointer",fontFamily:"var(--font-body)",fontSize:12,letterSpacing:1}}>Cancelar</button>
          <button className="btn-primary" onClick={save}>{isEdit ? "Salvar alterações" : "Criar produto"}</button>
        </div>
      </div>
    </div>
  );
}

function StockModal({ product, onSave, onClose }) {
  const [stock, setStock] = useState(JSON.parse(JSON.stringify(product.stock||{})));
  const update = (color,size,val) => setStock(s=>({...s,[color]:{...(s[color]||{}),[size]:parseInt(val)||0}}));
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:700,padding:40}} onClick={e=>e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title" style={{fontSize:28}}>Editar Estoque</div>
        <div className="modal-sub">{product.name}</div>
        <div style={{overflowX:"auto",marginTop:24}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr><th style={{background:"var(--black)",color:"var(--white)",padding:"10px 14px",textAlign:"left",fontFamily:"var(--font-mono)",fontSize:11,letterSpacing:2}}>Cor</th>{product.sizes.map(s=><th key={s} style={{background:"var(--black)",color:"var(--white)",padding:"10px 14px",fontFamily:"var(--font-mono)",fontSize:11,letterSpacing:2}}>{s}</th>)}</tr></thead>
            <tbody>{product.colors.map(c=>(<tr key={c}><td style={{padding:"8px 14px",borderBottom:"1px solid var(--border)",display:"flex",alignItems:"center",gap:8}}><div style={{width:14,height:14,borderRadius:"50%",background:COLOR_HEX[c]||"#888",border:"1px solid #ddd"}}/>{c}</td>{product.sizes.map(s=>(<td key={s} style={{padding:"6px 8px",borderBottom:"1px solid var(--border)",textAlign:"center"}}><input type="number" min={0} value={(stock[c]?.[s])??0} onChange={e=>update(c,s,e.target.value)} style={{width:72,padding:"6px 8px",border:"1.5px solid var(--border)",fontFamily:"var(--font-display)",fontSize:18,textAlign:"center",background:"var(--cream)",outline:"none"}}/></td>))}</tr>))}</tbody>
          </table>
        </div>
        <div style={{display:"flex",gap:12,justifyContent:"flex-end",marginTop:24}}>
          <button onClick={onClose} style={{padding:"12px 28px",border:"1.5px solid var(--border)",background:"transparent",cursor:"pointer",fontFamily:"var(--font-mono)",fontSize:12}}>Cancelar</button>
          <button className="btn-primary" onClick={()=>{onSave(stock);onClose();}}>Salvar estoque</button>
        </div>
      </div>
    </div>
  );
}

// ─── KIT FORM MODAL ──────────────────────────────────────────────────────────

function KitFormModal({ kit, onSave, onClose }) {
  const isEdit = !!kit;
  const [name, setName] = useState(kit?.name || "");
  const [desc, setDesc] = useState(kit?.desc || "");
  const [sizes, setSizes] = useState(kit?.sizes ? {...kit.sizes} : {});
  const [newSize, setNewSize] = useState("");
  const [newQty, setNewQty] = useState(1);
  const [error, setError] = useState("");
  const ALL_POSSIBLE = ["P","M","G","GG","G1","G2","G3"];

  const addSize = (s) => {
    if (!s) return;
    setSizes(prev => ({...prev, [s]: 1}));
    setNewSize("");
  };
  const removeSize = (s) => setSizes(prev => { const n={...prev}; delete n[s]; return n; });
  const updateQty = (s, v) => setSizes(prev => ({...prev, [s]: parseInt(v)||0}));

  const save = () => {
    if (!name.trim()) { setError("Nome do kit é obrigatório."); return; }
    if (Object.keys(sizes).length === 0) { setError("Adicione ao menos um tamanho."); return; }
    onSave({
      id: kit?.id || ("kit_" + Date.now()),
      name: name.trim(), desc: desc.trim(), sizes, active: kit?.active !== false,
    });
    onClose();
  };

  const inputStyle = {padding:"10px 14px",border:"1.5px solid var(--border)",background:"var(--cream)",fontFamily:"var(--font-body)",fontSize:14,color:"var(--black)",outline:"none"};
  const labelStyle = {fontSize:11,fontFamily:"var(--font-mono)",textTransform:"uppercase",letterSpacing:"1.5px",color:"var(--gray)",marginBottom:6,display:"block"};

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:520,padding:40}} onClick={e=>e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title" style={{fontSize:28}}>{isEdit ? "Editar Kit" : "Novo Kit"}</div>
        <div className="modal-sub">Configure a distribuição de tamanhos deste kit</div>

        <div style={{marginBottom:16}}>
          <label style={labelStyle}>Nome do Kit *</label>
          <input style={{...inputStyle,width:"100%"}} value={name} onChange={e=>setName(e.target.value)} placeholder="Ex: Kit Normal, Kit Plus Size" />
        </div>
        <div style={{marginBottom:20}}>
          <label style={labelStyle}>Descrição</label>
          <input style={{...inputStyle,width:"100%"}} value={desc} onChange={e=>setDesc(e.target.value)} placeholder="Ex: Tamanhos básicos para o dia a dia" />
        </div>

        <div style={{marginBottom:16}}>
          <label style={labelStyle}>Tamanhos e quantidades *</label>

          {/* Existing sizes */}
          {Object.keys(sizes).length > 0 && (
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
              {Object.entries(sizes).map(([s,n]) => (
                <div key={s} style={{display:"flex",alignItems:"center",gap:6,padding:"8px 12px",background:"var(--white)",border:"1.5px solid var(--accent)"}}>
                  <div style={{fontFamily:"var(--font-mono)",fontSize:12,fontWeight:700,minWidth:24}}>{s}</div>
                  <input type="number" min={0} value={n}
                    onChange={e => updateQty(s, e.target.value)}
                    style={{width:52,padding:"4px 8px",border:"1px solid var(--border)",fontFamily:"var(--font-display)",fontSize:22,textAlign:"center",background:"var(--cream)",outline:"none"}} />
                  <span onClick={() => removeSize(s)} style={{cursor:"pointer",color:"#dc2626",fontSize:14,lineHeight:1}}>✕</span>
                </div>
              ))}
            </div>
          )}

          {/* Add size */}
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {ALL_POSSIBLE.filter(s => !sizes[s]).map(s => (
              <button key={s} onClick={() => addSize(s)}
                style={{padding:"8px 14px",border:"1.5px dashed var(--border)",background:"var(--cream)",cursor:"pointer",fontFamily:"var(--font-mono)",fontSize:12,color:"var(--gray)",transition:"all 0.15s"}}
                onMouseEnter={e=>{e.target.style.borderColor="var(--gold)";e.target.style.color="var(--gold)";}}
                onMouseLeave={e=>{e.target.style.borderColor="var(--border)";e.target.style.color="var(--gray)";}}>
                + {s}
              </button>
            ))}
          </div>

          {/* Total preview */}
          {Object.keys(sizes).length > 0 && (
            <div style={{marginTop:16,padding:12,background:"var(--black)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontFamily:"var(--font-mono)",fontSize:11,color:"rgba(255,255,255,0.5)",letterSpacing:2}}>
                {Object.entries(sizes).map(([s,n])=>`${n}${s}`).join(" + ")}
              </div>
              <div style={{fontFamily:"var(--font-display)",fontSize:24,color:"var(--gold)"}}>
                {Object.values(sizes).reduce((a,b)=>a+b,0)} peças/kit
              </div>
            </div>
          )}
        </div>

        {error && <div className="alert-error" style={{marginBottom:16}}>{error}</div>}

        <div style={{display:"flex",gap:12,justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{padding:"12px 28px",border:"1.5px solid var(--border)",background:"transparent",cursor:"pointer",fontFamily:"var(--font-mono)",fontSize:12}}>Cancelar</button>
          <button className="btn-primary" onClick={save}>{isEdit ? "Salvar Kit" : "Criar Kit"}</button>
        </div>
      </div>
    </div>
  );
}

const DEFAULT_TIPOS = ["Terno","Blazer","Calça Social","Camisa","Camiseta","Vestido de Noiva","Saia","Conjunto","Colete","Sobretudo"];
const DEFAULT_MODELOS = ["Slim Fit","Classic Fit","Regular Fit","Slim Lapela","Duplo Botão","Princesa","Sereia","A-Line","Ball Gown","Tomara que Caia","Tubinho"];


function LojistasTab() {
  const [lojistas, setLojistas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editLojista, setEditLojista] = useState(null);
  const [toast, setToast] = useState("");

  useEffect(() => {
    supabase.from("lojista_requests").select("*").order("created_at", {ascending:false}).then(({data}) => {
      if (data) setLojistas(data);
      setLoading(false);
    });
  }, []);

  const deleteLojista = async (id) => {
    await supabase.from("lojista_requests").delete().eq("id", id);
    setLojistas(l => l.filter(x => x.id !== id));
  };

  const saveLojista = async (form, isEdit) => {
    const payload = { name: form.name, store_name: form.store_name, cnpj: form.cnpj, email: form.email, phone: form.phone, city: form.city, state: form.state, notes: form.notes, status: form.status || "active" };
    if (isEdit) {
      const { data } = await supabase.from("lojista_requests").update(payload).eq("id", form.id).select().single();
      setLojistas(l => l.map(x => x.id === form.id ? (data || {...form}) : x));
    } else {
      const { data } = await supabase.from("lojista_requests").insert(payload).select().single();
      if (data) setLojistas(l => [data, ...l]);
    }
    setToast(isEdit ? "Lojista atualizado!" : "Lojista cadastrado!");
    setShowForm(false); setEditLojista(null);
  };

  if (loading) return <div style={{padding:60,textAlign:"center",fontFamily:"var(--font-display)",fontSize:24,color:"var(--gray)"}}>Carregando...</div>;

  return (
    <div style={{maxWidth:1100,margin:"0 auto",padding:"0 40px 40px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
        <div>
          <div className="portal-title">LOJISTAS</div>
          <div className="portal-sub">{lojistas.length} lojista(s) cadastrado(s)</div>
        </div>
        <button className="btn-primary" onClick={() => { setEditLojista(null); setShowForm(true); }}>+ Cadastrar Lojista</button>
      </div>

      {lojistas.length === 0 && (
        <div style={{textAlign:"center",padding:"60px 0",color:"var(--gray)",fontSize:14,letterSpacing:1}}>Nenhum lojista cadastrado ainda.</div>
      )}

      <table className="admin-table">
        <thead>
          <tr><th>Nome</th><th>Loja</th><th>CNPJ</th><th>Cidade/UF</th><th>Contato</th><th>Ações</th></tr>
        </thead>
        <tbody>
          {lojistas.map(l => (
            <tr key={l.id}>
              <td><strong>{l.name}</strong></td>
              <td>{l.store_name}</td>
              <td style={{fontFamily:"var(--font-mono)",fontSize:12}}>{l.cnpj || "—"}</td>
              <td style={{color:"var(--gray)"}}>{l.city}{l.state ? ` — ${l.state}` : ""}</td>
              <td>
                {l.email && <div style={{fontSize:12}}>{l.email}</div>}
                {l.phone && <div style={{fontSize:12,color:"var(--gray)"}}>{l.phone}</div>}
              </td>
              <td>
                <div style={{display:"flex",gap:8}}>
                  <button className="btn-sm" onClick={() => { setEditLojista(l); setShowForm(true); }}>Editar</button>
                  <button className="btn-sm" style={{background:"#dc2626"}} onClick={() => deleteLojista(l.id)}>✕</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showForm && <LojistaFormModal lojista={editLojista} onSave={saveLojista} onClose={() => { setShowForm(false); setEditLojista(null); }} />}
      {toast && <Toast msg={toast} onClose={() => setToast("")} />}
    </div>
  );
}

function LojistaFormModal({ lojista, onSave, onClose }) {
  const isEdit = !!lojista;
  const empty = { name:"", store_name:"", cnpj:"", email:"", phone:"", city:"", state:"", notes:"", status:"active" };
  const [form, setForm] = useState(isEdit ? {...lojista} : empty);
  const setE = k => e => setForm(f => ({...f, [k]: e.target.value}));
  const inp = {padding:"10px 14px",border:"1px solid var(--border)",background:"var(--cream)",fontFamily:"var(--font-body)",fontSize:14,color:"var(--black)",outline:"none",width:"100%"};
  const lbl = {fontSize:10,fontFamily:"var(--font-body)",textTransform:"uppercase",letterSpacing:"2px",color:"var(--gray)",marginBottom:6,display:"block"};
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:580,padding:48}} onClick={e=>e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title">{isEdit ? "Editar Lojista" : "Novo Lojista"}</div>
        <div className="modal-sub">{isEdit ? `Editando: ${lojista.name}` : "Cadastrar lojista parceiro"}</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
          <div><label style={lbl}>Nome *</label><input style={inp} value={form.name} onChange={setE("name")} /></div>
          <div><label style={lbl}>Nome da loja *</label><input style={inp} value={form.store_name} onChange={setE("store_name")} /></div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
          <div><label style={lbl}>CNPJ</label><input style={inp} value={form.cnpj} onChange={setE("cnpj")} placeholder="00.000.000/0001-00" /></div>
          <div><label style={lbl}>Telefone / WhatsApp</label><input style={inp} value={form.phone} onChange={setE("phone")} placeholder="(11) 99999-9999" /></div>
        </div>
        <div style={{marginBottom:14}}><label style={lbl}>E-mail</label><input style={inp} value={form.email} onChange={setE("email")} type="email" /></div>
        <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:12,marginBottom:14}}>
          <div><label style={lbl}>Cidade</label><input style={inp} value={form.city} onChange={setE("city")} /></div>
          <div><label style={lbl}>UF</label><input style={inp} value={form.state} onChange={setE("state")} placeholder="SP" maxLength={2} /></div>
        </div>
        <div style={{marginBottom:20}}><label style={lbl}>Observações</label><textarea style={{...inp,resize:"vertical",minHeight:80}} value={form.notes} onChange={setE("notes")} /></div>
        <div style={{display:"flex",gap:12,justifyContent:"flex-end"}}>
          <button onClick={onClose} style={{padding:"12px 28px",border:"1px solid var(--border)",background:"transparent",cursor:"pointer",fontFamily:"var(--font-body)",fontSize:12,letterSpacing:1}}>Cancelar</button>
          <button className="btn-primary" onClick={() => onSave(form, isEdit)}>{isEdit ? "Salvar" : "Cadastrar"}</button>
        </div>
      </div>
    </div>
  );
}

function AdminPanel({ onLogout, kits, setKits }) {
  const [tab, setTab] = useState("dashboard");
  const [products, setProducts] = useState([]);
  const [clients, setClients] = useState([]);
  const [stores, setStores] = useState([]);
  const [showStoreForm, setShowStoreForm] = useState(false);
  const [editStore, setEditStore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [stockProduct, setStockProduct] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [toast, setToast] = useState("");

  // Load products and clients from Supabase
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      // Load products
      const { data: prods } = await supabase.from("products").select("*").order("created_at");
      if (prods) {
        const mapped = prods.map(p => ({
          ...p, group: p.group_name, desc: p.description,
          tipo: p.tipo || p.group_name, modelo: p.modelo || '', stock: {}
        }));
        // Load stock for all products
        const { data: stockRows } = await supabase.from("stock").select("*");
        mapped.forEach(p => {
          (p.colors||[]).forEach(c => {
            p.stock[c] = {};
            (p.sizes||[]).forEach(s => {
              const row = (stockRows||[]).find(r => r.product_id===p.id && r.color===c && r.size===s);
              p.stock[c][s] = row ? row.quantity : 0;
            });
          });
        });
        setProducts(mapped);
      }
      // Load lojista requests as clients
      const { data: reqs } = await supabase.from("lojista_requests").select("*").order("created_at", {ascending:false});
      if (reqs) setClients(reqs.map(r => ({id:r.id, name:r.name, store:r.store_name, cnpj:r.cnpj, city:r.city, email:r.email, status:r.status})));
      // Load stores
      const { data: storeData } = await supabase.from("stores").select("*").order("name");
      if (storeData) setStores(storeData);
      setLoading(false);
    };
    load();
  }, []);

  const approve = async id => {
    await supabase.from("lojista_requests").update({status:"active"}).eq("id", id);
    setClients(c => c.map(x => x.id===id ? {...x,status:"active"} : x));
  };
  const reject = async id => {
    await supabase.from("lojista_requests").update({status:"rejected"}).eq("id", id);
    setClients(c => c.map(x => x.id===id ? {...x,status:"rejected"} : x));
  };

  const saveProduct = async p => {
    const payload = {
      name: p.name, fabric: p.fabric, group_name: p.group,
      description: p.desc, badge: p.badge,
      tipo: p.tipo, modelo: p.modelo, main_photo: (p.mainPhotos||[])[0]||"", main_photos: p.mainPhotos||[], colors: p.colors, sizes: p.sizes,
      active: p.active !== false, photos: p.photos || {}
    };
    if (editProduct) {
      await supabase.from("products").update(payload).eq("id", p.id);
      setProducts(prev => prev.map(x => x.id===p.id ? {...p} : x));
      setToast("Produto atualizado!");
    } else {
      const { data } = await supabase.from("products").insert(payload).select().single();
      if (data) setProducts(prev => [...prev, {...p, id: data.id}]);
      setToast("Produto criado!");
    }
    setEditProduct(null);
  };

  const saveStock = async (pid, stock) => {
    const rows = [];
    Object.entries(stock).forEach(([color, sizes]) => {
      Object.entries(sizes).forEach(([size, quantity]) => {
        rows.push({product_id: pid, color, size, quantity});
      });
    });
    await supabase.from("stock").upsert(rows, {onConflict: "product_id,color,size"});
    setProducts(prev => prev.map(p => p.id===pid ? {...p, stock} : p));
    setToast("Estoque atualizado!");
  };

  const deleteProduct = async id => {
    await supabase.from("stock").delete().eq("product_id", id);
    await supabase.from("products").delete().eq("id", id);
    setProducts(prev => prev.filter(p => p.id!==id));
    setConfirmDelete(null);
    setToast("Produto removido.");
  };

  const toggleActive = async id => {
    const p = products.find(x => x.id===id);
    const newActive = p.active === false ? true : false;
    await supabase.from("products").update({active: newActive}).eq("id", id);
    setProducts(prev => prev.map(x => x.id===id ? {...x, active: newActive} : x));
  };

  if (loading) return (
    <div style={{minHeight:"100vh",background:"#f7f3ed",paddingTop:64,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{fontFamily:"var(--font-display)",fontSize:32,color:"var(--black)"}}>Carregando...</div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:"#f7f3ed",paddingTop:64}}>
      <div style={{background:"var(--black)",padding:"0 40px",position:"sticky",top:64,zIndex:100,display:"flex",alignItems:"center",height:56,gap:0,borderBottom:"1px solid rgba(255,255,255,0.1)"}}>
        {[["dashboard","Dashboard"],["produtos","Produtos"],["lojas","Lojas Parceiras"]].map(([id,label]) => (
          <button key={id} className={`portal-tab ${tab===id?"active":""}`} onClick={() => setTab(id)}>{label}</button>
        ))}
        <button onClick={onLogout} style={{marginLeft:"auto",fontFamily:"var(--font-mono)",fontSize:11,letterSpacing:1.5,textTransform:"uppercase",padding:"8px 16px",background:"transparent",color:"rgba(255,255,255,0.4)",border:"1px solid rgba(255,255,255,0.15)",cursor:"pointer"}}>Sair</button>
      </div>

      <div className="portal-content">

        {/* ── DASHBOARD ── */}
        {tab === "dashboard" && (
          <>
            <div className="portal-header"><div className="portal-title">PAINEL ADMIN</div></div>
            <div className="admin-grid">
              {[
                [products.filter(p=>p.active!==false).length.toString(),"Produtos ativos"],
                [clients.filter(c=>c.status==="active").length.toString(),"Lojistas ativos"],
                [clients.filter(c=>c.status==="pending").length.toString(),"Aprovações pendentes"],
                [products.reduce((acc,p)=>acc+Object.values(p.stock||{}).reduce((a,sizes)=>a+Object.values(sizes).reduce((x,y)=>x+y,0),0),0).toLocaleString(),"Peças em estoque"],
              ].map(([n,l]) => (
                <div className="admin-card" key={l}>
                  <div className="admin-card-num">{n}</div>
                  <div className="admin-card-label">{l}</div>
                </div>
              ))}
            </div>
            <h2 style={{fontFamily:"var(--font-display)",fontSize:28,marginBottom:16}}>ATIVIDADE RECENTE</h2>
            <table className="admin-table">
              <thead><tr><th>Evento</th><th>Detalhes</th><th>Data</th></tr></thead>
              <tbody>
                {[
                  ["Novo pedido","Moda Total — 60 peças","Hoje, 14:32"],
                  ["Cadastro pendente","Ana Modas — Salvador, BA","Hoje, 11:15"],
                  ["Estoque atualizado","Camiseta Gola Redonda — Preta","Ontem, 16:00"],
                  ["Cadastro aprovado","Moda CR — Curitiba, PR","Ontem, 09:30"],
                ].map(([e,d,t],i) => (
                  <tr key={i}><td>{e}</td><td style={{color:"var(--gray)"}}>{d}</td><td style={{fontFamily:"var(--font-mono)",fontSize:12,color:"var(--gray)"}}>{t}</td></tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* ── PRODUTOS ── */}
        {tab === "produtos" && (
          <>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:32,flexWrap:"wrap",gap:16}}>
              <div>
                <div className="portal-title">PRODUTOS</div>
                <div className="portal-sub">{products.length} produtos cadastrados</div>
              </div>
              <button className="btn-primary" onClick={() => { setEditProduct(null); setShowForm(true); }}>
                + Adicionar Produto
              </button>
            </div>

            {/* Group by tipo */}
            {[...new Set(products.map(p => p.tipo || p.group_name || p.group).filter(Boolean))].map(group => (
              <div key={group} style={{marginBottom:40}}>
                <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:16}}>
                  <div style={{fontFamily:"var(--font-display)",fontSize:24}}>{group}</div>
                  <div style={{height:1,flex:1,background:"var(--border)"}} />
                  <div style={{fontFamily:"var(--font-mono)",fontSize:11,color:"var(--gray)"}}>
                    {products.filter(p=>(p.tipo||p.group_name||p.group)===group).length} produto(s)
                  </div>
                </div>
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Produto</th>
                      <th>Tecido</th>
                      <th>Tipo</th>
                      <th>Modelo</th>
                      <th>Preço GQ</th>
                      <th>Cores</th>
                      <th>Tamanhos</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.filter(p=>(p.tipo||p.group_name||p.group)===group).map(p => (
                      <tr key={p.id}>
                        <td>
                          <div style={{fontWeight:600}}>{p.name}</div>
                          {p.badge && <span style={{fontSize:10,background:"var(--gold)",color:"#fff",padding:"2px 8px",fontFamily:"var(--font-mono)"}}>{p.badge}</span>}
                        </td>
                        <td style={{color:"var(--gray)",fontSize:12,maxWidth:180}}>{p.fabric}</td>
                        <td style={{color:"var(--gray)",fontSize:12}}>{p.tipo||"—"}</td>
                        <td style={{color:"var(--gray)",fontSize:12}}>{p.modelo||"—"}</td>
                        <td>
                          <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                            {p.colors.map(c => (
                              <div key={c} title={c} style={{width:16,height:16,borderRadius:"50%",background:COLOR_HEX[c]||"#888",border:"1px solid #ccc"}} />
                            ))}
                          </div>
                          <div style={{fontSize:11,color:"var(--gray)",marginTop:2}}>{p.colors.length} cor(es)</div>
                        </td>
                        <td style={{fontFamily:"var(--font-mono)",fontSize:11}}>{p.sizes.join(" · ")}</td>
                        <td>
                          <span className={`status-badge ${p.active===false?"status-rejected":"status-active"}`}
                            style={{cursor:"pointer"}} onClick={() => toggleActive(p.id)}>
                            {p.active===false ? "Inativo" : "Ativo"}
                          </span>
                        </td>
                        <td>
                          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                            <button onClick={() => { setEditProduct(p); setShowForm(true); }}
                              style={{background:"none",border:"1px solid var(--border)",padding:"4px 10px",cursor:"pointer",fontSize:11,fontFamily:"var(--font-mono)"}}>
                              ✏️ Editar
                            </button>
                            <button onClick={() => setStockProduct(p)}
                              style={{background:"none",border:"1px solid #86efac",color:"#166534",padding:"4px 10px",cursor:"pointer",fontSize:11,fontFamily:"var(--font-mono)"}}>
                              📦 Estoque
                            </button>
                            <button onClick={() => setConfirmDelete(p.id)}
                              style={{background:"none",border:"1px solid #fca5a5",color:"#dc2626",padding:"4px 10px",cursor:"pointer",fontSize:11,fontFamily:"var(--font-mono)"}}>
                              🗑️
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </>
        )}

        {/* ── LOJAS PARCEIRAS ── */}
        {tab === "lojas" && (
          <div style={{maxWidth:1100,margin:"0 auto",padding:"0 40px 40px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:32}}>
              <div>
                <div className="portal-title">LOJAS PARCEIRAS</div>
                <div className="portal-sub">{stores.length} loja(s) cadastrada(s)</div>
              </div>
              <button className="btn-primary" onClick={() => { setEditStore(null); setShowStoreForm(true); }}>+ Adicionar Loja</button>
            </div>

            {stores.length === 0 && (
              <div style={{textAlign:"center",padding:"80px 0",color:"var(--gray)",fontSize:14,letterSpacing:1,border:"2px dashed var(--border)"}}>
                <div style={{fontSize:40,marginBottom:16}}>🏪</div>
                <div style={{fontFamily:"var(--font-display)",fontSize:24,marginBottom:8}}>Nenhuma loja cadastrada</div>
                <div style={{fontSize:13}}>Clique em "+ Adicionar Loja" para começar.</div>
              </div>
            )}

            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(340px,1fr))",gap:16}}>
              {stores.map(s => (
                <div key={s.id} style={{background:"white",border:"1px solid var(--border)",padding:28,position:"relative",borderTop: s.active?"3px solid var(--gold)":"3px solid #e5e7eb"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
                    <div>
                      <div style={{fontFamily:"var(--font-display)",fontSize:22,letterSpacing:1,marginBottom:4}}>{s.name}</div>
                      <span style={{fontSize:10,padding:"3px 10px",fontFamily:"var(--font-body)",letterSpacing:1.5,textTransform:"uppercase",
                        background:s.active?"#fdf8ee":"#f3f4f6",color:s.active?"#8a6820":"#9ca3af",border:`1px solid ${s.active?"#e8d5a3":"#e5e7eb"}`}}>
                        {s.active ? "Ativa" : "Inativa"}
                      </span>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={() => { setEditStore(s); setShowStoreForm(true); }}
                        style={{padding:"6px 14px",fontSize:11,fontFamily:"var(--font-body)",letterSpacing:1,border:"1px solid var(--border)",background:"none",cursor:"pointer"}}>
                        ✏️ Editar
                      </button>
                      <button onClick={async () => {
                        if (!window.confirm(`Remover "${s.name}"?`)) return;
                        await supabase.from("stores").delete().eq("id", s.id);
                        setStores(st => st.filter(x => x.id !== s.id));
                        setToast("Loja removida.");
                      }} style={{padding:"6px 12px",fontSize:11,fontFamily:"var(--font-body)",border:"1px solid #fca5a5",color:"#dc2626",background:"none",cursor:"pointer"}}>
                        🗑️
                      </button>
                    </div>
                  </div>

                  <div style={{fontSize:13,color:"var(--gray)",lineHeight:2,marginBottom:16}}>
                    📍 {s.address}
                    {s.neighborhood && <span> — {s.neighborhood}</span>}
                    <br/>{s.city} — {s.state}
                    {s.cep && <span style={{fontFamily:"var(--font-mono)",fontSize:11}}> · CEP {s.cep}</span>}
                  </div>

                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                    {s.whatsapp && (
                      <a href={`https://wa.me/55${s.whatsapp.replace(/\D/g,"")}`} target="_blank" rel="noreferrer"
                        style={{textDecoration:"none",display:"inline-flex",alignItems:"center",gap:5,padding:"5px 12px",background:"#25D366",color:"white",fontSize:11,fontFamily:"var(--font-body)",letterSpacing:0.5}}>
                        WhatsApp
                      </a>
                    )}
                    {s.instagram && (
                      <a href={s.instagram.startsWith("http")?s.instagram:`https://instagram.com/${s.instagram.replace("@","")}`}
                        target="_blank" rel="noreferrer"
                        style={{textDecoration:"none",display:"inline-flex",alignItems:"center",gap:5,padding:"5px 12px",background:"var(--black)",color:"white",fontSize:11,fontFamily:"var(--font-body)",letterSpacing:0.5}}>
                        Instagram
                      </a>
                    )}
                    {s.website && (
                      <a href={s.website} target="_blank" rel="noreferrer"
                        style={{textDecoration:"none",display:"inline-flex",alignItems:"center",gap:5,padding:"5px 12px",border:"1px solid var(--border)",color:"var(--gray)",fontSize:11,fontFamily:"var(--font-body)"}}>
                        Site
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>


      {/* MODALS */}
      {showForm && (
        <ProductFormModal
          product={editProduct}
          allProducts={products}
          onSave={saveProduct}
          onClose={() => { setShowForm(false); setEditProduct(null); }}
        />
      )}
      {stockProduct && (
        <StockModal
          product={stockProduct}
          onSave={(stock) => saveStock(stockProduct.id, stock)}
          onClose={() => setStockProduct(null)}
        />
      )}
      {confirmDelete && (
        <div className="modal-overlay" onClick={() => setConfirmDelete(null)}>
          <div className="modal" style={{maxWidth:400,padding:40,textAlign:"center"}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:48,marginBottom:16}}>⚠️</div>
            <div style={{fontFamily:"var(--font-display)",fontSize:28,marginBottom:8}}>Remover produto?</div>
            <p style={{color:"var(--gray)",marginBottom:28,fontSize:14}}>Esta ação não pode ser desfeita. O produto será removido do catálogo.</p>
            <div style={{display:"flex",gap:12,justifyContent:"center"}}>
              <button onClick={() => setConfirmDelete(null)} style={{padding:"12px 28px",border:"1.5px solid var(--border)",background:"transparent",cursor:"pointer",fontFamily:"var(--font-mono)",fontSize:12}}>Cancelar</button>
              <button className="btn-primary" style={{background:"#dc2626"}} onClick={() => deleteProduct(confirmDelete)}>Sim, remover</button>
            </div>
          </div>
        </div>
      )}

      {showStoreForm && (
        <StoreFormModal
          store={editStore}
          onClose={() => { setShowStoreForm(false); setEditStore(null); }}
          onSave={s => {
            if (editStore) setStores(st => st.map(x => x.id === s.id ? s : x));
            else setStores(st => [...st, s]);
            setToast(editStore ? "Loja atualizada!" : "Loja cadastrada!");
            setShowStoreForm(false);
            setEditStore(null);
          }}
        />
      )}

      {toast && <Toast msg={toast} onClose={() => setToast("")} />}
    </div>
  );
}

function B2BPortal({ user, onLogout }) {
  const [tab, setTab] = useState("catalog");
  const [kits, setKits] = useState([]);
  if (user.role === "admin") return <AdminPanel onLogout={onLogout} kits={kits} setKits={setKits} />;
  return (
    <div className="portal">
      <div className="portal-nav">
        <div style={{fontFamily:"var(--font-mono)",fontSize:11,color:"rgba(255,255,255,0.4)",marginRight:32,letterSpacing:2}}>
          B2B
        </div>
        {[["catalog","Catálogo"],["stock","Estoque"],["order","Fazer Pedido"]].map(([id,label]) => (
          <button key={id} className={`portal-tab ${tab===id?"active":""}`} onClick={() => setTab(id)}>{label}</button>
        ))}
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:16}}>
          <span style={{fontFamily:"var(--font-mono)",fontSize:11,color:"rgba(255,255,255,0.4)"}}>
            {user.name} · {user.store}
          </span>
          <button onClick={onLogout} style={{fontFamily:"var(--font-mono)",fontSize:11,letterSpacing:1.5,textTransform:"uppercase",padding:"6px 14px",background:"transparent",color:"rgba(255,255,255,0.4)",border:"1px solid rgba(255,255,255,0.15)",cursor:"pointer"}}>Sair</button>
        </div>
      </div>
      <div className="portal-content">
        {tab === "catalog" && <B2BCatalogTab />}
        {tab === "stock" && <B2BStockTab />}
        {tab === "order" && <B2BOrderTab user={user} kits={kits} />}
      </div>
    </div>
  );
}

// ─── APP ──────────────────────────────────────────────────────────────────────

export default function App() {
  const [page, setPage] = useState("home");
  const [user, setUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [toast, setToast] = useState("");
  const [authLoading, setAuthLoading] = useState(true);

  // Admin login via hidden route: ?admin=1
  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (session) {
        const { data: profile } = await supabase.from("profiles").select("*").eq("id", session.user.id).single();
        if (profile && profile.role === "admin" && profile.status === "active") {
          setUser({ ...profile, email: session.user.email });
        }
      }
      setAuthLoading(false);
    });
    // Check URL for admin param
    if (window.location.search.includes("admin=1")) setShowLogin(true);
  }, []);

  if (authLoading) return (
    <div style={{minHeight:"100vh",background:"var(--black)",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:24}}>
      <div style={{fontFamily:"var(--font-display)",fontSize:56,color:"var(--white)",letterSpacing:4,fontWeight:300}}>DANIEL<span style={{color:"var(--gold)",fontStyle:"italic"}}>ABRAHAM</span></div>
      <div style={{width:40,height:1,background:"var(--gold)"}}></div>
    </div>
  );

  // Admin panel
  if (user && user.role === "admin") return (
    <>
      <style>{css}</style>
      <nav className="nav">
        <div className="nav-logo" style={{cursor:"pointer"}} onClick={() => setUser(null)}>DANIEL<span>ABRAHAM</span></div>
        <div className="nav-links">
          <span style={{fontFamily:"var(--font-body)",fontSize:10,color:"rgba(255,255,255,0.4)",letterSpacing:3,textTransform:"uppercase"}}>Painel Administrativo</span>
        </div>
        <button className="nav-btn outline" onClick={async()=>{await supabase.auth.signOut();setUser(null);}}>← Sair</button>
      </nav>
      <AdminPanel onLogout={async()=>{await supabase.auth.signOut();setUser(null);}} kits={[]} setKits={()=>{}} />
      {toast && <Toast msg={toast} onClose={() => setToast("")} />}
    </>
  );

  // Public site
  const NAV_LINKS = [
    ["catalog","Coleção"],["stores","Encontrar Loja"],["about","Sobre"],["contact","Contato"]
  ];

  return (
    <>
      <style>{css}</style>
      <nav className="nav">
        <div className="nav-logo" onClick={() => setPage("home")} style={{cursor:"pointer"}}>DANIEL<span>ABRAHAM</span></div>
        <div className="nav-links">
          {NAV_LINKS.map(([p,l]) => (
            <button key={p} className="nav-link" onClick={() => setPage(p)}
              style={{color: page===p ? "var(--gold)" : undefined}}>{l}</button>
          ))}
        </div>
        <a href="https://wa.me/5511942600546" target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
          <button className="nav-btn" style={{background:"#25D366",color:"#fff",display:"flex",alignItems:"center",gap:8}}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            WhatsApp
          </button>
        </a>
      </nav>

      {page === "home" && <HomePage setPage={setPage} />}
      {page === "catalog" && <CatalogPage setPage={setPage} />}
      {page === "stores" && <StoresPage />}
      {page === "about" && <AboutPage />}
      {page === "contact" && <ContactPage />}

      <footer className="footer">
        <div className="footer-logo">DANIEL<span>ABRAHAM</span></div>
        <div className="footer-divider"></div>
        <div style={{marginBottom:8}}>Alfaiataria B2B — Ternos e Trajes de Qualidade</div>
        <div>R. Xavantes 824, Brás, São Paulo — SP</div>
        <div style={{marginTop:16,fontSize:10,opacity:0.4}}>© 2025 Daniel Abraham. Todos os direitos reservados.</div>
      </footer>

      {showLogin && <LoginModal onClose={() => setShowLogin(false)} onLogin={u => { setUser(u); setToast("Bem-vindo ao painel!"); }} />}
      {toast && <Toast msg={toast} onClose={() => setToast("")} />}
    </>
  );
}
